/* custom-bag-easy.js — extracted from sections/custom-bag-easy.liquid on 2026-08-05
   (jar-builder.js method). Runs once per section render — data-ez-cfg's ATTRIBUTE
   VALUE is the section id (SECID), so the draft key ('ez-draft:'+SECID) and the IDB
   database name are byte-identical to the inline era: saved drafts and artwork
   survive the extraction. The DOM root id is the static #ez-easy. `defer` preserves
   the old bottom-of-section execution timing. */
(function(){
  'use strict';
  var SID = 'ez-easy';
  function init(){
    var root = document.getElementById(SID);
    if(!root || root.dataset.ezInit) return;
    try { localStorage.setItem('sm_last_builder', window.location.pathname); } catch(e){}
    var cfgEl = document.querySelector('[data-ez-cfg]');
    var SECID = cfgEl ? cfgEl.getAttribute('data-ez-cfg') : '';
    if(!cfgEl) return;
    root.dataset.ezInit = '1';
    var CFG; try{ CFG = JSON.parse(cfgEl.textContent); }catch(e){ return; }
    var BAG = CFG.bag || [], FEE = CFG.fee || [];
    var PRODUCTS = (CFG.products || []).filter(function(p){ return p && p.label; });
    if(!PRODUCTS.length){ PRODUCTS = [{key:'bags', label:'Mylar bags', sub:'', live:true, prefix:'size:', unit:'bags', note:''}]; }
    var LIVE = PRODUCTS.filter(function(p){ return p.live; });
    var PROD = LIVE.length ? LIVE[0] : PRODUCTS[0];
    var ANYCOLOR = 'Match my artwork';
    // BULK 0 = the "big order → talk to us" gate is OFF by design (owner
    // decision): large orders check out self-serve at ladder pricing. Every
    // BULK>0 branch below is therefore dead, and the 'bulk' step is unreachable
    // — intentional, not a bug. Set to CFG.bulk to re-enable the gate.
    var MINQ = CFG.minq || 1, MAXMB = CFG.maxmb > 0 ? CFG.maxmb : 9, MAXBYTES = MAXMB*1024*1024, BULK = 0;
    var NUDGE_WITHIN = (CFG.nudgewithin==null ? 50 : CFG.nudgewithin);
    var NUDGE_GAIN   = (CFG.nudgegain==null ? 5 : CFG.nudgegain);
    var NUDGE_BIG    = (CFG.nudgebig==null ? 20 : CFG.nudgebig);
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // How long a tapped option holds its "selected" state before the step
    // advances. This used to be 220ms at 15 call sites — across ~19 steps that
    // is ~4s of pure dead air, and it is why the first thing that happens after
    // a tap is stillness. 90ms is still long enough to register the mark()
    // highlight, and the rest of the confirmation now overlaps the exit fade
    // instead of running before it.
    var PICK_MS = 90;
    var GROUPS = (CFG.sizemins||'').split('\n').map(function(l){
      var i=l.indexOf(':'); if(i<0) return null;
      var m=parseInt(l.slice(0,i),10); if(isNaN(m)) return null;
      var sizes=l.slice(i+1).split(',').map(function(s){return s.trim();}).filter(Boolean);
      return sizes.length ? {min:m,sizes:sizes} : null;
    }).filter(Boolean);
    function minForSize(sz){ for(var i=0;i<GROUPS.length;i++){ if(GROUPS[i].sizes.indexOf(sz)>=0) return GROUPS[i].min; } return MINQ; }
    function shortSize(s){ return (s||'').replace(/\s*\(.*\)\s*/,''); }
    function parseLadder(str){
      return (str||'').split(',').map(function(t){
        var p=t.split(':'); if(p.length<2) return null;
        var m=parseInt(p[0],10), pc=parseFloat(p[1]);
        return (isNaN(m)||isNaN(pc)) ? null : {min:m,pct:pc};
      }).filter(Boolean).sort(function(a,b){return a.min-b.min;});
    }
    var LADDER = parseLadder((CFG.ladder||'').split('\n').join(','));
    var SIZELADDERS = (CFG.sizeladders||'').split('\n').map(function(l){
      var i=l.indexOf(':'); if(i<0) return null;
      var sizes=l.slice(0,i).split(',').map(function(s){return s.trim();}).filter(Boolean);
      var lad=parseLadder(l.slice(i+1));
      return (sizes.length && lad.length) ? {sizes:sizes,ladder:lad} : null;
    }).filter(Boolean);
    function ladderFor(sz){ for(var i=0;i<SIZELADDERS.length;i++){ if(SIZELADDERS[i].sizes.indexOf(sz)>=0) return SIZELADDERS[i].ladder; } return LADDER; }
    function pctFor(q,lad){ lad=lad||LADDER; var p=0; for(var i=0;i<lad.length;i++){ if(q>=lad[i].min) p=lad[i].pct; } return p; }
    function nextTier(q,lad){ lad=lad||LADDER; for(var i=0;i<lad.length;i++){ if(lad[i].min>q) return lad[i]; } return null; }
    function worthNudging(pool, nt, pct){
      if(!nt || !pool) return false;
      var need = nt.min - pool;
      if(need <= 0) return false;
      var withinPct = (need / pool) * 100;
      var gain = nt.pct - pct;
      if(gain < NUDGE_GAIN) return false;
      if(gain >= NUDGE_BIG) return true;
      return withinPct <= NUDGE_WITHIN;
    }
    var HIDDEN=(CFG.hiddensizes||'').split('\n').map(function(s){return s.trim();}).filter(Boolean);
    var SIZES=[]; BAG.forEach(function(v){ if(SIZES.indexOf(v.size)<0 && HIDDEN.indexOf(v.size)<0) SIZES.push(v.size); });
    if(!SIZES.length){ BAG.forEach(function(v){ if(SIZES.indexOf(v.size)<0) SIZES.push(v.size); }); }
    var COLORS=(CFG.colors||'').split('\n').map(function(l){
      var p=l.split('|'); if(p.length<2) return null;
      return {label:p[0].trim(), swatch:p[1].trim(), tokens:(p[2]||'').split(',').map(function(t){return t.trim();}).filter(Boolean)};
    }).filter(function(c){ return c && c.label; });
    (CFG.colorblocks||[]).forEach(function(b){
      if(b.label) COLORS.push({label:b.label, swatch:b.swatch||'#222', tokens:(b['for']||'').split(',').map(function(t){return t.trim();}).filter(Boolean)});
    });
    function colorsFor(size, base){
      return COLORS.filter(function(c){
        if(!c.tokens.length) return true;
        var sizeT=[], baseT=[];
        c.tokens.forEach(function(t){ if(/^(matte|holographic)$/i.test(t)) baseT.push(t.toLowerCase()); else sizeT.push(t); });
        return (!sizeT.length || sizeT.indexOf(size)>=0) && (!baseT.length || baseT.indexOf((base||'').toLowerCase())>=0);
      });
    }
    function findVariant(base,finish,spot,size,sides){
      var style=base + (finish?' + '+finish:'') + ((spot&&base==='Holographic')?' + Spot White':'');
      var want = sides==='Double' ? 'Double-sided' : 'Single-sided';
      for(var i=0;i<BAG.length;i++){ if(BAG[i].style===style && BAG[i].size===size && (BAG[i].sides===want || BAG[i].sides==null)) return BAG[i]; }
      return null;
    }
    function variant(){ return findVariant(S.base, S.finish||'', S.spot, S.size, S.sides||'Double'); }
    /* Pound upsell: the literal must match variant option2 byte-for-byte.
        If the size is ever renamed/hidden the whole feature quietly disappears
        instead of offering a dead button. */
    var PSIZE='QP/LB (13x15)';
    var PSIZE_OK = SIZES.indexOf(PSIZE)>=0;
    function priceAt(base,finish,spot,sides){ var v=findVariant(base,finish,spot,S.size,sides||S.sides||'Double'); return v?v.price:null; }
    function finishDisplay(v){ return v === 'Gloss' ? 'Gloss Varnish' : v; }
    // Display-only shortening for the review spec chips. "Holographic" is a
    // single 78px unbreakable word, and beside the 62px "MATERIAL" key in a
    // 149px chip there is nowhere for it to go — it either pushed the chevron
    // out of the chip or broke mid-word into "Holo gra…". Must NOT change
    // g.S.base itself: that string feeds findVariant() and the cart line
    // properties, so shortening the data would break variant lookup.
    function baseDisplay(v){ return v === 'Holographic' ? 'Holo' : v; }
    function styleOf(c){ var s=c.base; if(c.finish) s+=' + '+c.finish; if(c.spot && c.base==='Holographic') s+=' + Spot White'; return s; }
    function finishLabel(c){
      var bits=[];
      if(c.finish) bits.push(finishDisplay(c.finish));
      if(c.spot && c.base==='Holographic') bits.push('Spot White');
      return bits.length ? bits.join(' + ') : 'No special finish';
    }
    function specialOf(c){ return !!c.finish || (c.spot && c.base==='Holographic'); }
    function styleDisplay(c){ return styleOf(c).replace(/\bGloss\b/g, 'Gloss Varnish'); }
    function findFee(tier){ for(var i=0;i<FEE.length;i++){ if(FEE[i].tier===tier) return FEE[i]; } return null; }
    /* THE reorder-waiver judge (2026-09-08). A design that came in from a
        paid line — today a dashboard reorder reopened from the cart, later a
        design on file — carries d._of: the style, size, artwork URLs and QR it
        was paid for. The $25/$50 file-edit fee stays waived only while the FILE
        PREP is unchanged: same style, same size, same kept artwork on every
        printed side, same QR, no new upload. Quantity, color, name, notes and
        Double->Single are not prep and never re-charge. Every surface that
        prices, previews or emits the fee asks THIS function. The waiver itself
        is nothing but "don't emit _fee_id" plus the four contract props the
        dashboard stamps (cart-fee-guard re-attaches fees purely from _fee_id,
        and /cart/change.js replaces the whole properties object — which is how
        a quantity-only edit used to re-charge the fee). A drifted design is a
        NEW design: it gets a fresh _design_id so the customer's library never
        conflates the paid file with the changed one. */
    function keptUrlOf(f){ return (f && f.kept && f.url) ? f.url : ''; }
    function qrKeyRaw(v){
      v=String(v||'');
      if(v.indexOf('Generate from Instagram: ')===0) return 'ig:'+String(normIg(v.slice('Generate from Instagram: '.length))||'').toLowerCase();
      return v;
    }
    function qrKeyOf(d){
      if(d.qrLink) return 'ig:'+String(d.qrLink).toLowerCase();
      if(d.qr && d.qr.file) return 'new';
      if(d.qr && d.qr.kept && d.qr.url) return d.qr.url;
      if(EDIT && EDIT.qr) return qrKeyRaw(EDIT.qr);
      return '';
    }
    function feeStateFor(g, d){
      var special = specialOf(g.S) && FEE.length>0;
      var of = d && d._of;
      var same = false;
      if(special && of && of.paid){
        var newFile = !!((d.front && d.front.file) || (d.back && d.back.file) || (d.qr && d.qr.file));
        same = !newFile &&
          styleOf(g.S) === (of.style||'') &&
          (g.S.size||'') === (of.size||'') &&
          keptUrlOf(d.front) === (of.front||'') &&
          (g.S.sides!=='Double' || (!!of.back && keptUrlOf(d.back) === of.back)) &&
          qrKeyOf(d) === qrKeyRaw(of.qr);
      }
      var waived = special && same;
      if(of){
        if(waived) d.id = of.did || d.id;
        else if(d.id === of.did) d.id = uid();
      }
      return { special:special, waived:waived, did:d.id, order: of ? (of.order||'') : '',
               fee: (special && !waived) ? findFee(g.S.tier) : null };
    }
    function waiverProps(p, fs){
      if(!fs.waived) return p;
      p._fee_waived = '1';
      p._reorder_of = fs.order;
      p['Reorder of'] = fs.order;
      p['Setup'] = 'Paid with '+fs.order+' — not charged again';
      return p;
    }
    var DEFAULT_TIER=(function(){ for(var i=0;i<FEE.length;i++){ if(/standard/i.test(FEE[i].tier)) return FEE[i].tier; } return FEE.length?FEE[0].tier:''; })();
    function hasSpecial(){ return specialOf(S); }
    function money(c){ return '$'+(c/100).toFixed(2); }
    function unitWord(){ return (PROD && PROD.unit) ? PROD.unit : 'bags'; }
    // Count-aware variant: "1 bag" / "32 bags" (QP/LB has a minimum of 1).
    function unitFor(n){ var u = unitWord(); return n === 1 ? u.replace(/s$/,'') : u; }
    function uid(){ return 'd'+Math.random().toString(36).slice(2,8); }
    // Must escape QUOTES too: esc() output is interpolated into attribute values
    // (e.g. <img src="'+esc(url)+'">), and textContent->innerHTML leaves " and '
    // intact, allowing a crafted ?front= URL to break out of the attribute.
    function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];}); }
    // Opening the native file dialog mutates nothing in the DOM, so the tap reads
    // as dead — paint the is-opening overlay immediately, clear on window refocus
    // (dialog closed) or 2.5s (WebViews where the page never loses focus).
    function showOpening(el){
      el.classList.add('is-opening');
      var done = function(){ clearTimeout(t); window.removeEventListener('focus', done); el.classList.remove('is-opening'); };
      var t = setTimeout(done, 2500);
      window.addEventListener('focus', done, { once:true });
    }
    // Only http(s) URLs may be used as an artwork src/href; blocks javascript:,
    // data: and other schemes arriving via the edit-link query params.
    function safeUrl(u){ u=String(u==null?'':u); return /^https?:\/\//i.test(u) ? u : ''; }
    var EDIT=null, EDIT_KEY='', EDIT_VID='', EDIT_DID='', EDIT_FEEKEY='';
    (function(){
      var q;
      try{ q = new URLSearchParams(window.location.search); }catch(e){ return; }
      if(!q || !q.get('edit') || !q.get('vid')) return;
      EDIT = {
        key:   q.get('edit') || '',
        vid:   q.get('vid') || '',
        did:   q.get('did') || '',
        size:  q.get('size') || '',
        style: q.get('style') || '',
        sides: q.get('sides') || '',
        qty:   parseInt(q.get('qty'), 10) || 1,
        design:q.get('design') || '',
        color: q.get('color') || '',
        notes: q.get('notes') || '',
        ready: (q.get('ready') === 'Yes'),
        front: safeUrl(q.get('front')), frontname: q.get('frontname') || '',
        back:  safeUrl(q.get('back')),  backname:  q.get('backname') || '',
        // Set when that side's artwork property is a PENDING marker (send-later,
        // oversize, lost-in-draft) — those can't ride in front/back, which only
        // carry real /uploads/ URLs. Seeded as {later:true} slots at EDIT-apply.
        frontlater: q.get('frontlater') === '1',
        backlater:  q.get('backlater') === '1',
        feekey:q.get('feekey') || '',
        tier:  q.get('tier') || '',
        // Raw QR property value: an /uploads/ URL, a "Generate from Instagram: …"
        // string, or a PENDING marker. Decoded at EDIT-apply; anything we can't
        // decode is re-emitted verbatim so an edit never drops it.
        qr:    q.get('qr') || '',
        // The line arrived through a dashboard reorder with its setup fee
        // waived (cart link appends these when _fee_waived is set). Seeded as
        // d._of at EDIT-apply so feeStateFor() can keep the waiver honest.
        waived:    q.get('waived') === '1',
        reorderOf: q.get('reorder_of') || ''
      };
      EDIT_KEY=EDIT.key; EDIT_VID=EDIT.vid; EDIT_DID=EDIT.did; EDIT_FEEKEY=EDIT.feekey;
    })();
    function unpackStyle(c, styleStr){
      if(!styleStr) return;
      c.base   = /holograph/i.test(styleStr) ? 'Holographic' : 'Matte';
      c.finish = /gloss/i.test(styleStr) ? 'Gloss' : (/emboss/i.test(styleStr) ? 'Embossing' : '');
      c.spot   = /spot white/i.test(styleStr);
    }
    var CARTPOOLS={}, CARTCONTACT='';
    fetch('/cart.js',{cache:'no-store',headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok?r.json():null; })
      .then(function(c){
        if(!c) return; var p={};
        (c.items||[]).forEach(function(i){
          var pr=i.properties||{}; if(pr._fee_line==='1') return;
          var k=pr._pool_key||''; if(k.indexOf('size:')===0){ var sz=k.slice(5); p[sz]=(p[sz]||0)+i.quantity; }
        });
        if(EDIT && EDIT.size && p[EDIT.size]){
          p[EDIT.size] = Math.max(0, p[EDIT.size] - EDIT.qty);
        }
        CARTPOOLS=p;
        // Editing a line with pending artwork re-arms the contact gate, but the
        // contact the buyer already gave lives on the cart, not the line — recover
        // it or Save blocks on a question they've answered. Never overwrite typing.
        CARTCONTACT = String((c.attributes && c.attributes['Customer contact']) || '');
        if(EDIT && (EDIT.frontlater || EDIT.backlater) && !contact && CARTCONTACT) contact = CARTCONTACT;
        if(state.step==='dqty') paintQty();
        if(state.step==='review') paintReview();
      }).catch(function(){});
    function cartQty(sz){ return CARTPOOLS[sz]||0; }
    function sumSize(size, skipG, skipD){
      var t = cartQty(size);
      groups.forEach(function(g, gx){
        if(g.S.size !== size) return;
        g.designs.forEach(function(d, dx){
          if(gx===skipG && dx===skipD) return;
          t += (d.qty||0);
        });
      });
      return t;
    }
    function othersQty(){ return sumSize(S.size, gi, cur); }
    function poolMin(){ return minForSize(S.size); }
    function suggestQty(){ return Math.max(1, poolMin() - othersQty()); }
    function poolTotal(){ return sumSize(S.size, -1, -1); }
    function poolShort(){ return Math.max(0, poolMin() - poolTotal()); }
    function shortages(){
      var seen={}, out=[];
      groups.forEach(function(g){
        var sz=g.S.size;
        if(!sz || seen[sz]) return;
        seen[sz]=1;
        var need = minForSize(sz) - sumSize(sz,-1,-1);
        if(need > 0) out.push({size:sz, need:need, min:minForSize(sz)});
      });
      return out;
    }
    var SKEY = 'ez-draft:' + SECID; // same key as the inline era: existing drafts survive
    var idb=null, IDB_DB='ez-art:' + SECID, IDB_STORE='files';
    function idbOpen(){
      return new Promise(function(res, rej){
        if(idb) return res(idb);
        if(!window.indexedDB) return rej(new Error('no idb'));
        var rq=indexedDB.open(IDB_DB, 1);
        rq.onupgradeneeded=function(){ rq.result.createObjectStore(IDB_STORE); };
        rq.onsuccess=function(){ idb=rq.result; res(idb); };
        rq.onerror=function(){ rej(rq.error); };
      });
    }
    function idbSet(key, blob){
      return idbOpen().then(function(db){ return new Promise(function(res, rej){
        var tx=db.transaction(IDB_STORE,'readwrite');
        tx.objectStore(IDB_STORE).put(blob, key);
        tx.oncomplete=res; tx.onerror=function(){ rej(tx.error); };
      });});
    }
    function idbGet(key){
      return idbOpen().then(function(db){ return new Promise(function(res, rej){
        var tx=db.transaction(IDB_STORE,'readonly');
        var rq=tx.objectStore(IDB_STORE).get(key);
        rq.onsuccess=function(){ res(rq.result||null); };
        rq.onerror=function(){ rej(rq.error); };
      });});
    }
    function idbDelKey(key){
      return idbOpen().then(function(db){ return new Promise(function(res){
        var tx=db.transaction(IDB_STORE,'readwrite');
        tx.objectStore(IDB_STORE).delete(key);
        tx.oncomplete=res; tx.onerror=res;
      });});
    }
    function idbClearAll(){
      return idbOpen().then(function(db){ return new Promise(function(res){
        var tx=db.transaction(IDB_STORE,'readwrite');
        tx.objectStore(IDB_STORE).clear();
        tx.oncomplete=res; tx.onerror=res;
      });}).catch(function(){});
    }
    function artKey(designId, side){ return designId + ':' + side; }
    function idbSaveFile(designId, side, f){
      if(!f || !f.file){ idbDelKey(artKey(designId, side)).catch(function(){}); return; }
      idbSet(artKey(designId, side), f.file).catch(function(){});
    }
    var SVER = (function(){
      var s = (CFG.sizemins||'')+'|'+(CFG.sizeladders||'')+'|'+(CFG.ladder||'')+'|'+BAG.length+'|'+FEE.length;
      var h=0; for(var i=0;i<s.length;i++){ h=((h<<5)-h+s.charCodeAt(i))|0; }
      return String(h);
    })();
    var SMAXAGE = 24*60*60*1000;
    function worthSaving(){
      return groups.some(function(g){
        return !!g.S.size || (g.S.total > 0) || g.designs.some(function(d){
          return d.qty!=null || d.flavor || d.color || d.front || d.back || d.qr || d.qrLink;
        });
      });
    }
    function saveState(){
      if(EDIT) return;
      if(isDead()) { clearState(); return; }
      if(state.step==='intro' || state.step==='done') { clearState(); return; }
      if(!worthSaving()) { clearState(); return; }
      try{
        var payload = {
          v: SVER,
          t: Date.now(),
          step: state.step, mode: state.mode, splitMore: !!state.splitMore,
          seenReview: !!state.seenReview,
          gi: gi, cur: cur, contact: contact,
          prod: PROD ? PROD.key : '',
          groups: groups.map(function(g){
            return {
              S: g.S,
              designs: g.designs.map(function(d){
                return {
                  id:d.id, flavor:d.flavor, notes:d.notes, color:d.color, qty:d.qty,
                  qrLink:d.qrLink||'',
                  front: fileMeta(d.front),
                  back:  fileMeta(d.back),
                  qr:    fileMeta(d.qr)
                };
              })
            };
          })
        };
        localStorage.setItem(SKEY, JSON.stringify(payload));
      }catch(e){}
    }
    function fileMeta(f){
      if(!f) return null;
      if(f.kept)     return {kept:true, url:f.url, name:f.name};
      if(f.later)    return {later:true};
      if(f.oversize) return {oversize:true, name:f.name};
      if(f.file)     return {stored:true, name:f.name};
      if(f.lost)     return {lost:true, name:f.name};
      return {lost:true, name:f.name};
    }
    var DKEY = SKEY + ':dead';
    var saveTimer=null;
    function clearState(){
      clearTimeout(saveTimer); saveTimer=null;
      try{ localStorage.removeItem(SKEY); }catch(e){}
    }
    var dead = false;
    function killState(){
      dead = true;
      clearState();
      idbClearAll();
      try{ localStorage.setItem(DKEY, '1'); }catch(e){}
    }
    function isDead(){
      if(dead) return true;
      try{ return localStorage.getItem(DKEY) === '1'; }catch(e){ return false; }
    }
    function reviveState(){
      dead = false;
      try{ localStorage.removeItem(DKEY); }catch(e){}
    }
    function saveSoon(){ clearTimeout(saveTimer); saveTimer=setTimeout(saveState, 250); }
    function hydrateFiles(){
      if(!window.indexedDB) { markStoredAsLost(); return; }
      var jobs=[];
      groups.forEach(function(g){
        g.designs.forEach(function(d){
          ['front','back','qr'].forEach(function(side){
            var f=d[side];
            if(f && f.stored){
              jobs.push(
                idbGet(artKey(d.id, side)).then(function(blob){
                  if(blob){
                    var file = (blob instanceof File) ? blob
                             : new File([blob], f.name || 'artwork', {type: blob.type||''});
                    d[side] = {file:file, name:f.name || file.name};
                  } else {
                    d[side] = {lost:true, name:f.name};
                  }
                }).catch(function(){ d[side] = {lost:true, name:f.name}; })
                  .then(function(){ if(state.step===('d'+side) || state.step==='review') paintFor(side, d); })
              );
            }
          });
        });
      });
      Promise.all(jobs).then(function(){
        if(root.querySelector('[data-ez-restore]') && !root.querySelector('[data-ez-restore]').hidden){
          showRestoreNotice();
        }
        if(state.step==='review') paintReview();
      });
    }
    function markStoredAsLost(){
      groups.forEach(function(g){ g.designs.forEach(function(d){
        ['front','back','qr'].forEach(function(side){
          if(d[side] && d[side].stored) d[side]={lost:true, name:d[side].name};
        });
      });});
    }
    function paintFor(side, d){
      if(d !== D()) return;
      if(side==='qr'){ if(state.step==='dart') paintQr(); return; }
      if(steps[state.step] && steps[state.step].querySelector('[data-ez-drop="'+side+'"]')) paintDrop(side);
    }
    function stripParam(name){
      try{
        var clean = window.location.pathname +
                    window.location.search.replace(new RegExp('[?&]'+name+'=1'),'').replace(/^&/,'?') +
                    window.location.hash;
        window.history.replaceState({}, '', clean);
      }catch(e){}
    }
    function handleFreshParam(){
      if(window.location.search.indexOf('ezfresh=1') === -1) return;
      killState();
      stripParam('ezfresh');
    }
    handleFreshParam();
    (function heroPointer(){
      var hero = root.querySelector('.ez-hero');
      if(!hero || hero.classList.contains('ez-hero-img')) return;
      if(REDUCE) return;
      var tx=0, ty=0, tl=0;
      var cx=0, cy=0, cl=0;
      var raf=0;
      function tick(){
        var k = tl > 0 ? 0.20 : 0.12;
        cx += (tx - cx) * k;
        cy += (ty - cy) * k;
        cl += (tl - cl) * (tl > 0 ? 0.16 : 0.16);
        hero.style.setProperty('--mx', cx.toFixed(4));
        hero.style.setProperty('--my', cy.toFixed(4));
        hero.style.setProperty('--lit', cl.toFixed(4));
        var moving = Math.abs(tx-cx) > 0.0015 || Math.abs(ty-cy) > 0.0015 || Math.abs(tl-cl) > 0.0015;
        if(moving){ raf = requestAnimationFrame(tick); }
        else {
          raf = 0;
          cx=tx; cy=ty; cl=tl;
          hero.style.setProperty('--mx', cx.toFixed(4));
          hero.style.setProperty('--my', cy.toFixed(4));
          hero.style.setProperty('--lit', cl.toFixed(4));
        }
      }
      function wake(){ if(!raf) raf = requestAnimationFrame(tick); }
      function track(e){
        var r = hero.getBoundingClientRect();
        if(!r.width || !r.height) return;
        tx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width  - 0.5) * 2));
        ty = Math.max(-1, Math.min(1, ((e.clientY - r.top ) / r.height - 0.5) * 2));
        tl = 1;
        wake();
      }
      function release(){ tx=0; ty=0; tl=0; wake(); }
      hero.addEventListener('pointermove',  track);
      hero.addEventListener('pointerleave', release);
      hero.addEventListener('pointercancel',release);
      hero.addEventListener('pointerdown',  function(e){ if(e.pointerType!=='mouse') track(e); });
      hero.addEventListener('pointerup',    function(e){ if(e.pointerType!=='mouse') release(); });
      document.addEventListener('visibilitychange', function(){ if(document.hidden) release(); });
    })();
    window.addEventListener('pageshow', function(e){
      if(e.persisted) window.location.reload();
    });
    var DONE = null;
    (function handleDoneParam(){
      if(window.location.search.indexOf('ezdone=1') === -1) return;
      killState();
      try{
        var raw = sessionStorage.getItem(SKEY+':done');
        if(raw) DONE = JSON.parse(raw);
        sessionStorage.removeItem(SKEY+':done');
      }catch(e){}
      stripParam('ezdone');
    })();
    function reviveFileMeta(m){
      if(!m) return null;
      if(m.stored) return {stored:true, name:m.name};
      return m;
    }
    function restoreState(){
      if(EDIT) return false;
      if(isDead()){ clearState(); return false; }
      var raw;
      try{ raw = localStorage.getItem(SKEY); }catch(e){ return false; }
      if(!raw) return false;
      var p;
      try{ p = JSON.parse(raw); }catch(e){ clearState(); return false; }
      if(!p || p.v !== SVER || !p.groups || !p.groups.length){ clearState(); return false; }
      if(!p.t || (Date.now() - p.t) > SMAXAGE){ clearState(); return false; }
      if(isDead()){ clearState(); return false; }
      try{
        groups = p.groups.map(function(g){
          return {
            id: uid(),
            S: g.S,
            designs: (g.designs||[]).map(function(d){
              return {
                id:d.id||uid(), flavor:d.flavor||'', notes:d.notes||'',
                color:d.color||'', qty:(d.qty==null?null:d.qty),
                qrLink:d.qrLink||'',
                front:reviveFileMeta(d.front), back:reviveFileMeta(d.back),
                qr:reviveFileMeta(d.qr)
              };
            })
          };
        });
        if(!groups.length) return false;
        /* Pre-2026-07-31 saves can carry the print-ready opt-out, which no
            longer exists — left alone, feeAnswered() would be false and pruneDrafts
            would EAT the restored group. Normalize to the mandatory-fee model. */
        groups.forEach(function(g){
          if(!g.S) return;
          if(g.S.readyAns==='Yes' && !g.S.tier) g.S.tier=DEFAULT_TIER;
          g.S.ready=false; if(g.S.readyAns) g.S.readyAns='No';
        });
        contact = p.contact || '';
        if(p.prod){
          for(var i=0;i<PRODUCTS.length;i++){ if(PRODUCTS[i].key===p.prod){ PROD=PRODUCTS[i]; break; } }
        }
        useGroup(Math.min(p.gi||0, groups.length-1), p.cur||0);
        state.mode = p.mode || 'config';
        state.splitMore = !!p.splitMore;
        state.seenReview = !!p.seenReview || p.step==='review';
        /* DOM presence isn't wizard validity — a stale draft step absent
           from flow() stranded Continue/Back entirely (audit 2026-08-24) */
        state.step = (steps[p.step] && (p.step==='quote' || p.step==='dkind' || flow().indexOf(p.step)!==-1)) ? p.step : 'review';
        return true;
      }catch(e){ clearState(); return false; }
    }
    function showRestoreNotice(){
      var el=root.querySelector('[data-ez-restore]');
      if(!el) return;
      var n=lostFiles();
      root.querySelector('[data-ez-restoretx]').innerHTML = n
        ? ('<b>Welcome back.</b> Everything was saved, except your '+
           (n>1?('artwork files ('+n+')'):'artwork file')+'. Please add '+(n>1?'them':'it')+' again.')
        : '<b>Welcome back.</b> Everything was saved.';
      el.classList.toggle('is-warn', n>0);
      el.classList.remove('is-leaving');
      el.hidden=false;
      if(!n){
        setTimeout(function(){
          if(el.hidden || el.classList.contains('is-warn')) return;
          /* pin the height so .is-leaving's height:0 has a start value — the
              notice used to fade then display:none in one frame and the content
              below snapped up (owner report 08-05) */
          el.style.height=el.offsetHeight+'px'; void el.offsetWidth;
          el.classList.add('is-leaving');
          setTimeout(function(){ if(el.classList.contains('is-leaving')){ el.hidden=true; el.classList.remove('is-leaving'); el.style.height=''; } }, 500);
        }, 2500);
      }
    }
    function lostFiles(){
      var n=0;
      groups.forEach(function(g){
        g.designs.forEach(function(d){
          if(d.front && d.front.lost) n++;
          if(g.S.sides==='Double' && d.back && d.back.lost) n++;
        });
      });
      return n;
    }
    var groups, gi, S, designs, cur, contact;
    function newDesign(){ return {id:uid(), flavor:'', notes:'', front:null, back:null, qr:null, qrLink:'', color:'', qty:null}; }
    function newGroup(){
      return { id:uid(),
               S:{size:null, total:null, base:'Matte', finish:null, spot:false, sides:'Double', ready:false, readyAns:null, tier:'', totalTouched:false},
               designs:[newDesign()] };
    }
    function useGroup(i, designIdx){
      gi = Math.max(0, Math.min(i, groups.length-1));
      S = groups[gi].S;
      designs = groups[gi].designs;
      cur = (typeof designIdx === 'number') ? Math.max(0, Math.min(designIdx, designs.length-1)) : 0;
    }
    function reset(){
      groups = [newGroup()];
      contact = '';
      useGroup(0, 0);
      if(typeof state !== 'undefined' && state) state.mode='config';
    }
    function D(){ return designs[cur]; }
    reset();
    var CONFIG_ORDER=['intro','product','size','gtotal','gsplit','base','finish','ready','tier','sides','dart','dcolor','dmore','review','done'];
    var DESIGN_ORDER=['dart','dcolor','dqty','dmore','review','done'];
    var ORDER=CONFIG_ORDER;
    function applicable(id){
      switch(id){
        case 'product': return PRODUCTS.length > 1;
        case 'quote': return false;
        case 'dkind': return false;
        case 'dqty': return state.mode==='design';
        case 'ready': return false; /* opt-out step removed 2026-07-31; the fee is mandatory when the finish needs it */
        case 'tier':  return hasSpecial() && FEE.length>0;
        default: return true;
      }
    }
    function flow(){ return (state.mode==='design' ? DESIGN_ORDER : CONFIG_ORDER).filter(applicable); }
    var TITLES={product:'Product',size:'Size',gtotal:'How many',gsplit:'Designs',base:'Material',finish:'Finish',sides:'Sides',tier:'Spot gloss file edits',
                dart:'Artwork',dcolor:'Color',dqty:'Quantity',dmore:'Designs',review:'Review'};
    var card=root.querySelector('[data-ez-card]');
    var stage=root.querySelector('[data-ez-stage]');
    var steps={}; root.querySelectorAll('[data-ez-step]').forEach(function(el){ steps[el.getAttribute('data-ez-step')]=el; });
    var backBtn=root.querySelector('[data-ez-back]');
    var progress=root.querySelector('[data-ez-progress]');
    var stepLab=root.querySelector('[data-ez-steplab]');
    var barFill=root.querySelector('[data-ez-barfill]');
    var primary=root.querySelector('[data-ez-primary]');
    var cartLink=root.querySelector('[data-ez-cartlink]');
    var finePrint=root.querySelector('[data-ez-fineprint]');
    var qtyInp=root.querySelector('[data-ez-qty]');
    var state={step:'intro', busy:false, ret:null, mode:'config', splitMore:false,
               seenReview:false,
               fromFork:false};
    var NEEDS_BTN={intro:1, gtotal:1, finish:1, dart:1, dqty:1, review:1, done:1};
    var NO_BTN={bulk:1, quote:1, dkind:1};
    function stepAnswered(){
      switch(state.step){
        case 'size':   return !!S.size;
        case 'gsplit': return !state.splitMore && designs.length>0;
        case 'base':   return !!S.base;
        case 'sides':  return !!S.sides;
        case 'tier':   return !!S.tier;
        case 'dcolor': return !!D().color;
        case 'product':return PRODUCTS.length>1 && !!PROD;
        default:       return false;
      }
    }
    function primaryLabel(){
      if(state.ret==='review' && state.step!=='review' && state.step!=='done'){
        var onFeePath = (state.step==='finish' || state.step==='tier');
        if(onFeePath && !feeAnswered(S, groups[gi])) return 'Next: spot gloss file edits';
        return 'Done, back to review';
      }
      switch(state.step){
        case 'intro':  return CFG.startlabel || 'Start my order';
        case 'review': return EDIT ? 'Save changes' : 'Add to cart';
        case 'done':   return 'Go to cart';
        case 'dart':
          return 'Continue';
        default:
          if(!NEEDS_BTN[state.step] && stepAnswered()){
            var kept='';
            switch(state.step){
              case 'gsplit': kept=designs.length+' design'+(designs.length>1?'s':''); break;
              case 'size':   kept=shortSize(S.size); break;
              case 'sides':  kept=(S.sides==='Double'?'front and back':'front only'); break;
              case 'base':   kept=S.base; break;
              case 'tier':   kept=S.tier; break;
              case 'dcolor': kept=D().color; break;
            }
            return kept ? ('Keep '+kept) : 'Continue';
          }
          return 'Continue';
      }
    }
    function milestoneFor(pos, total){
      if(!total || total < 6) return '';
      if(state.step==='review') return EDIT ? '' : 'Last step. Check it and you\u2019re done';
      if(state.ret==='review') return '';
      var frac = pos/total;
      var stretch = Math.ceil(total * 0.8);
      if(pos === stretch) return 'Almost there'; /* no "!" — BRAND §2 (jar port 08-05) */
      var half = Math.ceil(total/2);
      if(pos === half && half !== stretch) return 'Halfway there';
      return '';
    }
    function paintMilestone(pos, total){
      var el=root.querySelector('[data-ez-milestone]');
      if(!el) return;
      var msg = milestoneFor(pos, total);
      el.hidden = !msg;
      if(msg) el.textContent = msg;
      // The milestone is absolutely positioned (zero layout height), so the step
      // heading below sat 1px under it. Reserve real clearance only when shown.
      /* clearance band is ALWAYS reserved in CSS now (.ez-progress margin-bottom) — the toggle moved the whole stage 16px per milestone step (jar port 08-05) */
    }
    function paintStepLabel(){
      var inFlow = state.step!=='intro' && state.step!=='done';
      if(inFlow && state.step!=='bulk'){
        var f=flow().filter(function(s){ return s!=='intro' && s!=='done'; });
        var i=f.indexOf(state.step);
        if(i>=0){
          var dn = '';
          if(groups.length>1) dn += ' \u00b7 Bag '+(gi+1);
          if(designs.length>1 && state.step.charAt(0)==='d' && state.step!=='dmore') dn += ' \u00b7 Design '+(cur+1);
          var perDesign = f.filter(function(s){ return DESIGN_STEPS[s] && state.mode==='config'; });
          var reps = perDesign.length;
          var extra = reps * Math.max(0, designs.length - 1);
          var total = f.length + extra;
          var firstD = perDesign.length ? f.indexOf(perDesign[0]) : -1;
          var lastD  = perDesign.length ? f.indexOf(perDesign[perDesign.length-1]) : -1;
          var pos;
          if(firstD < 0 || i < firstD){
            pos = i + 1;
          } else if(i <= lastD){
            pos = firstD + cur*reps + (i - firstD) + 1;
          } else {
            pos = i + extra + 1;
          }
          var wide = window.matchMedia('(min-width:900px)').matches;
          var titlePart = wide ? (' \u00b7 '+(TITLES[state.step]||'')) : '';
          stepLab.textContent='Step '+pos+' of '+total+titlePart+dn;
          barFill.style.width=Math.round((pos/total)*100)+'%';
          paintMilestone(pos, total);
        }
      } else if(state.step==='bulk'){ stepLab.textContent='Big order'; paintMilestone(0,0); }
      else if(state.step==='quote'){ stepLab.textContent='Quote'; paintMilestone(0,0); }
      else if(state.step==='dkind'){ stepLab.textContent='Add more'; paintMilestone(0,0); }
    }
    function paintChrome(){
      if(state.step!=='review' && !state.busy){ primary.disabled=false; }
      var inFlow = state.step!=='intro' && state.step!=='done';
      progress.hidden = !inFlow;
      var f0 = flow().filter(function(s){ return s!=='intro' && s!=='done'; })[0];
      var atFirstStep = (state.step === f0);
      /*
        "Nothing behind" must mean prev() genuinely has nowhere to go, and it did
        not. prev() explicitly handles dart-in-design-mode — it drops the draft
        design and returns to dmore (or review) — but this flag hid the button
        anyway, because in design mode dart IS the first step of flow(), and a
        freshly added design leaves the group unfinished so hasOrder() is false.

        Reproduced: dmore -> "Add more to this order" -> dkind -> "Another design"
        landed on dart with the back button hidden AND the run-total disabled
        (state.seenReview is still false on that path, since review was never
        visited). The buyer was stranded with no way out but to finish a design
        they had just decided they did not want.

        Mirroring prev()'s own early-exit keeps the two in step: if prev() can
        move, the button is offered.
      */
      var draftDesign = (state.step==='dart' && state.mode==='design');
      var nothingBehind = atFirstStep && groups.length===1 && state.ret!=='review'
                          && !draftDesign && !hasReviewable();
      var hideBack = state.busy || nothingBehind;
      backBtn.hidden = !inFlow;
      backBtn.style.visibility = (inFlow && hideBack) ? 'hidden' : 'visible';
      backBtn.disabled = hideBack || !inFlow;
      paintStepLabel();
      var show = (!!NEEDS_BTN[state.step] || state.ret==='review' || stepAnswered()) && !NO_BTN[state.step];
      if(state.step==='gsplit' && state.splitMore) show=true;
      /* On the tier step with the fee question unanswered, advance() can only
          swallow the click (go('tier') === current step). ret==='review' used to
          force a solid blue "Next: spot gloss file edits" here anyway — the
          top dead-click element in Clarity. Ghost it like any unanswered step. */
      if(state.step==='tier' && !feeAnswered(S, groups[gi])) show=false;
      primary.classList.toggle('is-ghosted', !show);
      primary.setAttribute('aria-disabled', String(!show));
      primary.tabIndex = show ? 0 : -1;
      var ctaEl = root.querySelector('.ez-cta');
      if(ctaEl) ctaEl.classList.toggle('is-ghosted', !show && (!stickyErr || stickyErr.hidden));
      primary.textContent = show ? primaryLabel() : 'Pick an option above to continue';
      var ctaHero = root.querySelector('.ez-cta');
      if(ctaHero) ctaHero.classList.toggle('is-hero', state.step==='intro');
      if(state.step==='intro'){
        primary.innerHTML = esc(primaryLabel()) + '<span class="ez-go" aria-hidden="true">\u2192</span>';
      }
      cartLink.hidden = true;
      var isReview = (state.step==='review');
      if(stickyErr && !isReview){
        stickyErr.hidden=true;
        if(footEl) footEl.classList.remove('has-err');
      }
      if(card){
        card.classList.toggle('is-review', isReview);
        card.classList.toggle('is-intro', state.step==='intro');
        if(isReview){ root.style.removeProperty('--ez-h'); }
        else { fitCard(); }
      }
      paintRunTotal();
      paintBadge();
      saveSoon();
      finePrint.hidden = state.step!=='review';
    }
    var navSeq = 0, navTimer = null, navBusy = false;
    var holdStops = [], reviewHolds = [];
    function releaseHolds(){
      holdStops.forEach(function(fn){ try{ fn(); }catch(e){} });
      reviewHolds.forEach(function(fn){ try{ fn(); }catch(e){} });
    }
    function settleSteps(id){
      var to = steps[id];
      Object.keys(steps).forEach(function(k){
        var el = steps[k];
        el.classList.remove('is-out');
        if(k !== id){
          el.classList.remove('is-in');
          el.hidden = true;
          var fe = el.querySelector('[data-ez-fileerr]');
          if(fe) fe.hidden = true;
        }
      });
      to.hidden = false;
      afterShow(id);
      stage.scrollTop = 0;
      /* done included: it now arrives in place (no reload to scroll for us),
          and the review page the buyer just left is tall */
      if(id === 'review' || id === 'done'){ window.scrollTo(0, Math.max(0, root.offsetTop - 8)); }
      state.step = id;
      paintChrome();
      focusHead(to);
    }
    function go(id){
      var to = steps[id];
      if(!to) return;
      /* An edit opened from the review card can only be BACKED OUT of while
          the buyer is still inside the size/total/split cluster; moving anywhere else
          commits it. See prev() for why the undo exists at all. */
      if(state.undo && ['product','size','gtotal','gsplit'].indexOf(id) < 0) state.undo = null;
      var from = steps[state.step];
      releaseHolds();
      disarmRunTot(); /* an armed leave-confirm is stale once navigation happens */
      hideCtaNudge(); // any blocked-CTA message is stale once navigation succeeds
      state.step = id;
      paintStep(id);
      navSeq++;
      clearTimeout(navTimer); navTimer = null;
      if(from === to){ navBusy=false; root.classList.remove('is-animating'); settleSteps(id); return; }
      if(REDUCE){
        /* instant swap, same double-tap absorption as the animated path —
           dropping the guards let one double-tap advance two steps
           (audit 2026-08-24). 250ms sits inside the animated envelope. */
        navBusy=true;
        var rseq=navSeq;
        root.classList.add('is-animating');
        settleSteps(id);
        navTimer=setTimeout(function(){
          navBusy=false; navTimer=null;
          if(rseq===navSeq) root.classList.remove('is-animating');
        }, 250);
        return;
      }
      navBusy = true;
      var seq = navSeq;
      /*
        The old code also scheduled a bare `setTimeout(navBusy=false, 360)` here.
        It was dead (the 190ms timer below cleared navBusy first) AND unsafe: it
        was never captured or cleared, so a stale one from transition N could
        clear navBusy in the middle of transition N+1. Removed.
      */
      root.classList.add('is-animating');
      if(from) from.classList.add('is-out');
      navTimer = setTimeout(function(){
        navBusy = false;
        if(seq !== navSeq) return;
        navTimer = null;
        /*
          Apply the entrance START state while the step is still display:none.

          This ordering is the whole fix. Previously settleSteps() ran first —
          it unhides the step and then forces layout three separate times
          (stage.scrollTop, fitCard's getBoundingClientRect via paintChrome, and
          focusHead's .focus()). Each flush resolved the incoming step at
          opacity 1 / transform none. Adding .is-in AFTER that did not set a
          start state at all: it started a 200ms transition TOWARD opacity 0,
          and the double rAF removed it ~33ms later so it reversed back. The
          step flashed on solid, dipped (to ~0.74 at 60fps, ~0.55 at 30fps) and
          recovered — on every one of the ~19 steps. The designed rise never
          happened, and no frame was ever dropped, which is why it profiled
          clean while looking wrong.

          A transition cannot start on an element with no box, so setting the
          class here makes opacity:0/translateY(10px) the first style the step is
          ever rendered with. The explicit reflow then commits it, and removing
          the class starts a real entrance on the next frame. No double rAF.
        */
        to.classList.add('is-in');
        settleSteps(id);
        void to.offsetWidth;
        to.classList.remove('is-in');
        // hold the stage inert until the entrance has actually finished, so a
        // fast tap can't hit an option on a screen that is still fading up
        setTimeout(function(){
          if(seq === navSeq) root.classList.remove('is-animating');
        }, 200);
      }, 130);
      paintChrome();
    }
    function focusHead(pane){ var q=pane.querySelector('.ez-q,.ez-h1,.ez-rvtitle'); if(q){ try{ q.focus({preventScroll:true}); }catch(e){} } }
    function hasUsableFile(f){ return !!(f && (f.file || f.kept || f.oversize || f.stored || f.later)); }
    function requireFileOk(){
      var stepEl = steps[state.step];
      var req = stepEl && stepEl.getAttribute('data-ez-requires-file');
      if(!req) return true;
      var sides = (req==='art')
        ? (S.sides==='Double' ? ['front','back'] : ['front'])
        : [req];
      var missing=null;
      for(var i=0;i<sides.length;i++){
        if(!hasUsableFile(D()[sides[i]])){ missing=sides[i]; break; }
      }
      if(!missing) return true;
      var host = stepEl.querySelector('[data-ez-drop="'+missing+'"]');
      var fe = stepEl.querySelector('[data-ez-fileerr]');
      if(!fe){
        fe=document.createElement('p'); fe.className='ez-fielderr'; fe.setAttribute('data-ez-fileerr','');
        fe.setAttribute('role','alert');   // announce upload errors to screen readers
        var grid = stepEl.querySelector('[data-ez-artgrid]');
        if(grid && grid.parentNode) grid.parentNode.insertBefore(fe, grid.nextSibling);
        else stepEl.appendChild(fe);
      }
      fe.hidden=false;
      var which = (req==='art' && S.sides==='Double')
        ? (missing==='front' ? 'front ' : 'back ') : '';
      fe.textContent = (D()[missing] && D()[missing].lost)
        ? 'That file was lost when the page reloaded. Please pick it again.'
        : 'We need your '+which+'artwork to print your '+unitWord().replace(/s$/,'')+'s. Add it or choose to send it later.';
      /*
        Scroll the offending drop zone into view before flashing it. There WAS
        already feedback here — a 1.5s red ring on the drop zone plus a 12.5px
        error line — but both sit ~280px above the CTA, so a buyer whose thumb
        is on Continue could miss them and read the tap as "nothing happened".
        This makes the response land where they are looking. It is one
        contributor to this page's dead clicks, not the sole cause.
      */
      if(host){
        try{ host.scrollIntoView({behavior:'smooth', block:'center'}); }
        catch(e){ host.scrollIntoView(); }
        flash(host);
      }
      /* Repeat feedback at the CTA itself: on the second+ press the error line
          and ring above are already showing, so without this the press changes
          nothing in view. */
      ctaNudge(fe.textContent);
      return false;
    }
    function missingArtStep(g, d){
      if(!hasUsableFile(d.front)) return 'dart';
      if(g.S.sides==='Double' && !hasUsableFile(d.back)) return 'dart';
      return null;
    }
    function advance(){
      if(navBusy || state.busy) return;
      if(!requireFileOk()) return;
      if(state.ret==='review' && !isNewGroup()){
        if(!feeAnswered(S)){
          /*
            go('tier') from the tier step itself short-circuits in go() (from===to)
            with zero visible change — the "Next: set up your file" 6-clicks-dead
            bug from the Jul 27–31 Clarity sessions, renamed 07-31 but not fixed.
            paintChrome() now ghosts the CTA here; this branch is the belt to that
            suspender for any path that still lands a click (keyboard, stale paint).
          */
          if(state.step==='tier'){ nudgeStepOptions(); return; }
          go('tier'); return;
        }
        state.ret=null; go('review'); return;
      }
      if(state.ret==='review' && isNewGroup()) state.ret=null;
      next();
    }
    function isNewGroup(){
      var g=groups[gi];
      return !g.S.sides || g.designs.some(function(d){ return d.qty==null; });
    }
    function designDone(d){ return d.qty != null; }
    function feeAnswered(S2, g){
      /* Since 2026-07-31 there is no print-ready opt-out — a special finish
          always needs an edit level picked. readyAns is vestigial (normalized to 'No'
          on restore/edit so pre-change saved orders survive pruneDrafts). */
      if(!(specialOf(S2) && FEE.length > 0)) return true;
      // a group whose every design keeps its paid file prep owes no edit level
      if(g && g.designs && g.designs.length && g.designs.every(function(d){ return feeStateFor(g,d).waived; })) return true;
      return !!S2.tier;
    }
    function groupDone(g){
      return !!g.S.size && !!g.S.sides && feeAnswered(g.S, g) &&
             g.designs.length > 0 && g.designs.every(designDone);
    }
    function pruneDrafts(){
      groups.forEach(function(g){
        if(g.S.total > 0 && g.designs.length && g.designs.every(function(d){ return d.qty==null; })){
          var parts=splitEven(g.S.total, g.designs.length);
          g.designs.forEach(function(d,i){ d.qty=parts[i]; });
        }
        var keep = g.designs.filter(designDone);
        if(keep.length) g.designs = keep;
        var live = groupTotalOf(g);
        if(live > 0) g.S.total = live;
      });
      var kept = groups.filter(groupDone);
      if(kept.length) groups = kept;
      if(!groups.length) groups = [newGroup()];
      useGroup(Math.min(gi, groups.length-1), 0);
    }
    function dropDraftDesign(){
      if(designs.length > 1 && !designDone(D())){
        designs.splice(cur, 1);
        cur = Math.max(0, designs.length - 1);
        return true;
      }
      return false;
    }
    function dropDraftGroup(){
      if(groups.length > 1 && !groupDone(groups[gi])){
        groups.splice(gi, 1);
        useGroup(Math.min(gi, groups.length - 1), 0);
        return true;
      }
      return false;
    }
    function next(){
      if(state.step==='dart' && !requireFileOk()) return;
      var f=flow(), i=f.indexOf(state.step);
      if(state.step==='dcolor' && state.mode==='config' && cur < designs.length-1){
        cur++;
        go('dart');
        return;
      }
      if(i>=0 && i<f.length-1) go(f[i+1]);
    }
    function prev(){
      if(navBusy || state.busy) return;
      /* An edit-from-cart edits exactly ONE line — saveEdit() is hard-wired to
          groups[0].designs[0]. paintReview already hides "Another design" / "A different kind
          of bag" while EDIT is set, but Back from the review card fell through to 'dmore',
          whose fork offers the very same thing: anything built there was rendered on the
          review (and counted in its total) and then silently dropped on save. An edit has no
          previous step, so Back means cancel — go back to the cart. */
      if(EDIT && state.step==='review'){ window.location.href = '/cart'; return; }
      /* Back from review walks the full config flow, one step at a time.
          Two resets make that work: mode must be 'config' (review can be entered with
          mode still 'design' after a design-mode add, and DESIGN_ORDER would truncate
          the walk to the last design's steps), and cur must point at the LAST design —
          pruneDrafts() resets cur to 0 on review entry, which would make the
          dart/dcolor backward iteration cover design 1 only and skip the rest.
          There used to be a `dmore && hasOrder() -> review` rule below; combined with
          this walk it ping-ponged review <-> dmore forever, which is why Back from
          review could never reach anything earlier. Removed — the fork's own
          "That's everything" button and the tappable run-total are the ways forward. */
      if(state.step==='review'){
        state.mode='config';
        state.ret=null; /* else a stale ret would bounce the NEXT Back straight back here */
        cur = Math.max(0, designs.length-1);
        go('dmore');
        return;
      }
      if(state.step==='gsplit' && state.splitMore){
        state.splitMore=false;
        if(designs.length>4) applySplit(4);
        paintSplit(); paintChrome();
        return;
      }
      if(state.step==='dart' && state.mode==='design'){
        if(!designDone(D())){
          dropDraftDesign();
          state.mode='config';
          if(state.ret==='review'){ state.ret=null; go('review'); return; }
          go('dmore'); return;
        }
        /* A COMPLETED design in design mode is not a draft to bail out of —
            it's a step on the backward walk. Switch to config mode and fall through so
            the dart/dcolor per-design iteration below keeps stepping backward instead
            of bouncing to dmore. */
        state.mode='config';
      }
      /* Backing out of a size/total edit that started on the review card.
          Picking a new size deliberately clears S.total and EVERY design qty (new size =
          new minimum + ladder). That leaves a fully-built group indistinguishable from an
          abandoned draft, and BOTH dropDraftGroup() below and pruneDrafts()'s
          `groups.filter(groupDone)` then delete it — designs, artwork and all. Restore the
          snapshot instead, so Back means "cancel my edit". */
      if(state.undo && state.undo.gi === gi && state.ret==='review' &&
         (state.step==='product' || state.step==='size' || state.step==='gtotal' || state.step==='gsplit')){
        var u = state.undo;
        S.size = u.size; S.total = u.total; S.totalTouched = u.totalTouched;
        if(u.qtys.length === designs.length) designs.forEach(function(d,i){ d.qty = u.qtys[i]; });
        state.undo=null; state.ret=null; state.mode='config'; state.splitMore=false; state.fromFork=false;
        go('review');
        return;
      }
      if(groups.length>1 && !groupDone(groups[gi]) &&
         (state.step==='product' || state.step==='size' || state.step==='gtotal' || state.step==='gsplit')){
        var wasReview = (state.ret==='review');
        var wasFork   = !!state.fromFork;
        dropDraftGroup();
        state.mode='config'; state.splitMore=false; state.ret=null; state.fromFork=false;
        go(wasFork ? 'dkind' : (wasReview || hasOrder() ? 'review' : 'dmore'));
        return;
      }
      if(state.ret==='review'){ state.ret=null; go('review'); return; }
      if(state.step==='dart' && state.mode==='config' && cur > 0){
        cur--;
        go('dcolor');
        return;
      }
      if(state.step==='quote'){ go('product'); return; }
      if(state.step==='bulk'){ go('gtotal'); return; }
      if(state.step==='dkind'){ go('dmore'); return; }
      var f=flow(), i=f.indexOf(state.step);
      if(i>0) go(f[i-1]);
    }
    backBtn.addEventListener('click', prev);
    function mark(host, btn, cls){
      cls=cls||'is-on';
      host.querySelectorAll('.'+cls).forEach(function(x){
        x.classList.remove(cls);
        /* selection was class-only — a SR user re-entering a step heard flat
           buttons with no current choice (WCAG 4.1.2, audit 2026-08-24) */
        if(x.hasAttribute('aria-pressed')) x.setAttribute('aria-pressed','false');
      });
      btn.classList.add(cls);
      btn.setAttribute('aria-pressed','true');
    }
    function otherGroupsQty(){
      var t = cartQty(S.size);
      groups.forEach(function(g, gx){
        if(gx===gi || g.S.size!==S.size) return;
        g.designs.forEach(function(d){ t += (d.qty||0); });
      });
      return t;
    }
    function groupQty(){ var t=0; designs.forEach(function(d){ t += (d.qty||0); }); return t; }
    function groupTotalOf(g){ var t=0; g.designs.forEach(function(d){ t += (d.qty||0); }); return t; }
    function pricingQty(){ return otherGroupsQty() + (groupQty() || S.total || 0); }
    function curPct(){ return pctFor(pricingQty(), ladderFor(S.size)); }
    function configQty(){ return groupQty() || S.total || 0; }
    function pdiff(a, b){
      if(a==null || b==null) return '';
      if(a===b) return 'Same price';
      var pct  = curPct();
      var each = Math.round(a*(1-pct/100)) - Math.round(b*(1-pct/100));
      var qty  = configQty();
      if(!qty) return (a>b ? 'Costs more' : 'Costs less');
      var tot  = each * qty;
      if(tot === 0) return 'Same price';
      return (tot > 0 ? ('+' + money(tot)) : ('Save ' + money(Math.abs(tot))));
    }
    function optionBtn(host, on, title, sub, tag, lead){
      var b=document.createElement('button'); b.type='button';
      b.className='ez-opt'+(on?' is-on':'');
      b.setAttribute('aria-pressed', on?'true':'false');
      b.innerHTML=(lead||'')+'<span class="ez-opt-main"><span class="ez-opt-h">'+esc(title)+'</span>'+
        (sub?'<span class="ez-opt-s">'+esc(sub)+'</span>':'')+'</span>'+(tag?'<span class="ez-opt-tag">'+esc(tag)+'</span>':'');
      host.appendChild(b); return b;
    }
    function paintStep(id){
      if(id==='product'){
        var hp=root.querySelector('[data-ez-products]'); hp.innerHTML='';
        PRODUCTS.forEach(function(p){
          var b=optionBtn(hp, PROD.key===p.key, p.label, p.sub||'', p.live?'':'Quote only');
          b.addEventListener('click', function(){
            PROD=p; mark(hp,b);
            if(!p.live){ setTimeout(function(){ go('quote'); },PICK_MS); return; }
            setTimeout(advance,PICK_MS);
          });
        });
      }
      if(id==='quote'){
        root.querySelector('[data-ez-quoteq]').textContent = 'We\u2019ll quote your '+(PROD.label||'order').toLowerCase();
        root.querySelector('[data-ez-quotetx]').textContent = PROD.note
          || 'We print these to order. Send us a message or request a quote and an account manager will get right back to you.';
      }
      if(id==='size'){
        var h=root.querySelector('[data-ez-sizes]'); h.innerHTML='';
        var dims={}, dmin=Infinity, dmax=0;
        SIZES.forEach(function(sz){
          var m=sz.match(/\((\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\)/i);
          if(m){ var d={w:parseFloat(m[1]),h:parseFloat(m[2])}; d.big=Math.max(d.w,d.h);
            dims[sz]=d; dmin=Math.min(dmin,d.big); dmax=Math.max(dmax,d.big); }
        });
        SIZES.forEach(function(sz){
          var lead='';
          if(dims[sz]){
            var d=dims[sz];
            var big = (dmax>dmin) ? 24 + (d.big-dmin)/(dmax-dmin)*20 : 44;
            var k = big/d.big;
            lead='<span class="ez-shape"><i style="width:'+Math.round(d.w*k)+'px;height:'+Math.round(d.h*k)+'px"></i></span>';
          }
          var sub = 'Min order is '+minForSize(sz)+' '+unitFor(minForSize(sz));
          var b=optionBtn(h, S.size===sz, sz, sub, '', lead);
          b.addEventListener('click', function(){
            var changed = (S.size!==sz);
            if(changed){
              S.size=sz; S.total=null; S.totalTouched=false;
              designs.forEach(function(x){
                x.qty=null;
                if(x.color && x.color!==ANYCOLOR){
                  var ok = colorsFor(sz, S.base).some(function(c){ return c.label===x.color; });
                  if(!ok) x.color='';
                }
              });
            }
            if(S.sides==='Double' && !findVariant(S.base||'Matte','',false,sz,'Double')) S.sides='Single';
            mark(h,b);
            if(state.ret==='review' && changed){
              setTimeout(function(){ go('gtotal'); }, PICK_MS);
              return;
            }
            setTimeout(advance,PICK_MS);
          });
        });
      }
      if(id==='base'){
        setDeltaNote('base');
        var h2=root.querySelector('[data-ez-bases]'); h2.innerHTML='';
        var sd=S.sides||'Double';
        var pm=priceAt('Matte','',false,sd), ph=priceAt('Holographic','',false,sd);
        [{v:'Matte',s:'Smooth, classic, no shine.'},
         {v:'Holographic',s:'Rainbow shine that moves in the light.',tag:pdiff(ph,pm)}].forEach(function(o){
          if(priceAt(o.v,'',false,'Single')==null && priceAt(o.v,'',false,'Double')==null) return;
          // material roll icons (shared sm-v2 assets, URLs via the config island)
          var ic=(o.v==='Holographic'?CFG.iconholo:CFG.iconmatte);
          var b=optionBtn(h2, S.base===o.v, o.v, o.s, o.tag||'',
            ic?'<img class="ez-opt-icon" src="'+ic+'" alt="" width="40" height="40" loading="lazy">':'');
          b.addEventListener('click', function(){
            var changed = (S.base !== o.v);
            if(changed){
              S.base=o.v; S.finish=null; S.spot=false; S.readyAns=null; S.tier=''; S.ready=false;
              designs.forEach(function(x){
                if(x.color && x.color!==ANYCOLOR){
                  var ok = colorsFor(S.size, S.base).some(function(c){ return c.label===x.color; });
                  if(!ok) x.color='';
                }
              });
            }
            mark(h2,b);
            if(state.ret==='review' && changed){
              setTimeout(function(){ go('finish'); }, PICK_MS);
              return;
            }
            setTimeout(advance,PICK_MS);
          });
        });
      }
      if(id==='finish'){
        setDeltaNote('finish');
        var h3=root.querySelector('[data-ez-finishes]'); h3.innerHTML='';
        var base=priceAt(S.base,'',false,S.sides||'Double');
        [{v:'',h:'No finish',s:'Clean print, best price. You can add finishes on a reorder.'},
         {v:'Gloss',h:'Gloss Varnish',s:'Shiny, wet-look highlights on parts of your design.'},
         {v:'Embossing',h:'Embossing',s:'Raised parts you can feel with your fingers.'}].forEach(function(o){
          var p=priceAt(S.base,o.v,S.spot,S.sides||'Double');
          if(o.v && p==null) return;
          var holo=(S.base==='Holographic');
          var fic=(o.v==='Gloss'?(holo?CFG.iconglossholo:CFG.icongloss)
                  :o.v==='Embossing'?(holo?CFG.iconembossholo:CFG.iconemboss)
                  :(holo?CFG.icondiceholo:CFG.icondice));
          var b=optionBtn(h3, S.finish===o.v, o.h, o.s, o.v?pdiff(p,base):'',
            fic?'<img class="ez-opt-icon ez-opt-icon--fin" src="'+fic+'" alt="" width="68" height="46" loading="lazy">':'');
          b.addEventListener('click', function(){
            var already = (S.finish===o.v);
            if(!already){ S.finish=o.v; S.readyAns=null; S.tier=''; S.ready=false; }
            mark(h3,b); paintSpot();
            if(!already){ primary.textContent = primaryLabel(); paintStepLabel(); }
            if(already) setTimeout(advance,180);
          });
        });
        if(S.finish===null){ S.finish=''; var f0=h3.querySelector('.ez-opt'); if(f0) f0.classList.add('is-on'); }
        paintSpot();
      }
      if(id==='sides'){
        setDeltaNote('sides');
        var h4=root.querySelector('[data-ez-sides]'); h4.innerHTML='';
        var ps=priceAt(S.base,S.finish||'',S.spot,'Single'), pdb=priceAt(S.base,S.finish||'',S.spot,'Double');
        [{v:'Double',h:'Front and back',s:'You\u2019ll add a second file.'},
         {v:'Single',h:'Front only',s:'Back stays plain.',tag:pdiff(ps,pdb)}].forEach(function(o){
          if(o.v==='Double' && pdb==null) return;
          var b=optionBtn(h4, S.sides===o.v, o.h, o.s, o.tag||'');
          b.addEventListener('click', function(){
            S.sides=o.v;
            /* back files stay DORMANT in state/IDB when the buyer flips to
               Front only (a compare-tap destroyed every uploaded back file,
               audit 2026-08-24) — re-picking Front and back restores them.
               The cart emitters gate on S.sides so a dormant back never
               rides into a single-sided line. */
            mark(h4,b); setTimeout(advance,PICK_MS);
          });
        });
      }
      if(id==='tier'){
        /* The removed "print-ready?" step used to carry the why \u2014 its
            explanation now lives in this step's hint so the fee never reads as
            unexplained. Marks readyAns 'No' so pre-change persistence stays coherent. */
        S.readyAns='No'; S.ready=false;
        var extras=[];
        if(S.finish) extras.push(S.finish);
        if(S.spot && S.base==='Holographic') extras.push('Spot White');
        var th=root.querySelector('[data-ez-tierhint]');
        if(th) th.textContent = (extras.join(' + ')||'This finish')+
          ' needs its own layer built into your file \u2014 we do that for you. Charged once per design, not per bag.';
        var h6=root.querySelector('[data-ez-tiers]'); h6.innerHTML='';
        FEE.forEach(function(f){
          var tag = designs.length>1 ? (money(f.price)+' \u00d7 '+designs.length) : money(f.price);
          var sub = (f.tier===DEFAULT_TIER) ? 'Most designs need this one.' : 'For intricate art — lots of fine detail or many elements.';
          var b=optionBtn(h6, S.tier===f.tier, f.tier, sub, tag);
          b.addEventListener('click', function(){ S.tier=f.tier; mark(h6,b); setTimeout(advance,PICK_MS); });
        });
      }
      if(id==='dart'){
        paintBadge();
        root.querySelector('[data-ez-artq]').textContent = designs.length>1
          ? ('Design '+(cur+1)+' artwork')
          : 'Add your design';
        root.querySelector('[data-ez-name]').value=D().flavor||'';
        root.querySelector('[data-ez-notes]').value=D().notes||'';
        var nmi=root.querySelector('[data-ez-name]');
        if(nmi && !nmi.dataset.enterBound){
          nmi.dataset.enterBound='1';
          nmi.addEventListener('keydown', function(e){
            if(e.key==='Enter'){ e.preventDefault(); nmi.blur(); }
          });
        }
        var nw=root.querySelector('[data-ez-noteswrap]');
        var nt=root.querySelector('[data-ez-notestoggle]');
        var hasNote=!!(D().notes||'').trim();
        nw.hidden=!hasNote;
        nt.setAttribute('aria-expanded', hasNote?'true':'false');
        nt.textContent = hasNote ? '\u2212 Hide note' : '+ Add note';
        if(nt && !nt.dataset.bound){
          nt.dataset.bound='1';
          nt.addEventListener('click', function(){
            var open = nw.hidden;
            nw.hidden = !open;
            nt.setAttribute('aria-expanded', open?'true':'false');
            nt.textContent = open ? '\u2212 Hide note' : '+ Add note';
            if(open) root.querySelector('[data-ez-notes]').focus();
          });
        }
        var backCol=root.querySelector('[data-ez-backcol]');
        var isDouble = S.sides==='Double';
        backCol.hidden = !isDouble;
        root.querySelector('[data-ez-artgrid]').classList.toggle('has-back', isDouble);
        root.querySelector('[data-ez-frontcap]').textContent = isDouble ? 'Front' : 'Your artwork';
        paintDrop('front');
        if(isDouble) paintDrop('back');
        paintLaterLink();
        paintQr(true);
      }
      if(id==='dcolor'){
        root.querySelector('[data-ez-colorq]').textContent = designs.length>1
          ? ('Bag color for '+(D().flavor || ('design '+(cur+1))))
          : 'Pick your bag color';
        var h7=root.querySelector('[data-ez-colors]'); h7.innerHTML='';
        colorsFor(S.size,S.base).forEach(function(c){
          var b=document.createElement('button'); b.type='button';
          b.className='ez-sw'+(D().color===c.label?' is-on':'');
          /* DISPLAY-ONLY alias strip: "Baby Blue/Sky Blue" ellipsized to "Baby…"
              on tight tiles — the slash alias ate the whole line. D().color and the
              cart still carry the full label (same rule as the "Holo" spec chip:
              shorten for display, never for data). */
          b.innerHTML='<i style="background:'+esc(c.swatch)+'"></i><span>'+esc(String(c.label).split('/')[0].trim())+'</span>';
          b.addEventListener('click', function(){ D().color=c.label; mark(h7,b); setTimeout(advance,PICK_MS); });
          h7.appendChild(b);
        });
        var ns=document.createElement('button'); ns.type='button';
        ns.className='ez-sw is-any'+(D().color===ANYCOLOR?' is-on':'');
        ns.innerHTML='<i class="ez-wheel"></i><span>Not sure, match my art</span>';
        ns.addEventListener('click', function(){ D().color=ANYCOLOR; mark(h7,ns); setTimeout(advance,PICK_MS); });
        h7.appendChild(ns);
        fitColorGrid();
      }
      if(id==='gtotal'){ paintTotal(); }
      if(id==='gsplit'){ paintSplit(); }
      if(id!=='gsplit' && state.splitMore) state.splitMore=false;
      if(id==='dqty'){
        root.querySelector('[data-ez-qtyq]').textContent = designs.length>1 ? ('How many of design '+(cur+1)+'?') : ('How many '+unitWord()+'?');
        paintQty();
      }
      if(id==='bulk'){
        var bt=root.querySelector('[data-ez-bulktx]');
        if(bt && S.size) bt.textContent='Orders this big get better pricing. Message us: about '+(S.total||0)+' '+shortSize(S.size)+' '+unitFor(S.total||0)+'.';
      }
      if(id==='dmore'){
        var h8=root.querySelector('[data-ez-more]'); h8.innerHTML='';
        var pool=poolTotal(), lad=ladderFor(S.size), pct=pctFor(pool,lad), nt=nextTier(pool,lad), sh=poolShort();
        var hint;
        if(sh>0){
          hint='You have '+pool+' '+unitFor(pool)+'. You need '+sh+' more to reach the minimum of '+poolMin()+'.';
        } else {
          hint='All set: '+pool+' '+unitFor(pool)+' across '+designs.length+' design'+(designs.length>1?'s':'')+
               (pct>0?(', '+pct+'% off.'):'.');
          if(nt && worthNudging(pool, nt, pct)){
            hint += ' Add '+(nt.min-pool)+' more and every one drops to '+nt.pct+'% off.';
          }
        }
        root.querySelector('[data-ez-morehint]').textContent=hint;
        /*
          Finish-first, and no yes/no framing.

          These used to read "Yes, add more" then "No, that's everything", which
          made the buyer map their intent onto the question before they could
          answer it \u2014 and it put the ez-fork-done button (the SOLID blue one,
          and the path most people take) second, so the loudest control was the
          one fewer people want. Each label now states its own action, which
          also means the order can be finish-first without a "No" appearing
          above a "Yes". "Add more to this order" matches the heading of the
          step it leads to (dkind: "Add more to your order").
        */
        var n=optionBtn(h8, false, 'That\u2019s everything', 'Take me to my order.');
        n.classList.add('ez-fork-done');
        n.insertAdjacentHTML('afterbegin','<span class="ez-fork-ic" aria-hidden="true">\u2713</span>');
        n.addEventListener('click', function(){ go('review'); });
        var y=optionBtn(h8, false, 'Add more to this order', 'Another design, or a different bag.');
        y.classList.add('ez-fork-add');
        y.insertAdjacentHTML('afterbegin','<span class="ez-fork-ic" aria-hidden="true">+</span>');
        y.addEventListener('click', function(){ go('dkind'); });
        /* Pound-bag upsell (moved here from the review 2026-07-31 — this
            step IS the add-more moment). Same suppression as before via poundOfferFor:
            group unfinished, already pound, matching pound exists, EDIT. Deliberately
            NOT the fork's option style: an upsell must not wear navigation's clothes. */
        var pvm=poundOfferFor(groups[gi]);
        if(pvm){
          var pnm=groups[gi].designs.length;
          var pFeeM=(specialOf(S) && FEE.length>0) ? findFee(S.tier) : null;
          /* One pound bag is cloned PER DESIGN — with several designs the
              singular headline undersold what the tap does, and the count hid mid-
              sentence. Lead with it: "Add 3 matching pound bags". */
          var pdm=document.createElement('button'); pdm.type='button'; pdm.className='ez-poundcard';
          pdm.innerHTML='<span class="ez-pound-kick">Popular add-on</span>'+
            '<span class="ez-pound-main"><b>'+(pnm===1?'Add a matching pound bag':'Add '+pnm+' matching pound bags')+'</b>'+
            '<small>'+(pnm===1?'Same design &amp; finish':'One per design — same finish')+' &middot; '+esc(PSIZE)+
            (pnm===1?'':' &middot; adds '+pnm+' bags, qty 1 each')+
            (pFeeM ? (' &middot; +'+(pnm>1?pnm+'× ':'')+money(pFeeM.price)+' spot gloss file edits') : '')+
            '</small></span>'+
            '<span class="ez-pound-price">+'+money(pvm.price*pnm)+'</span>';
          pdm.addEventListener('click', function(){ clonePoundGroup(gi); });
          h8.appendChild(pdm);
        }
      }
      if(id==='dkind'){
        var hk=root.querySelector('[data-ez-kind]'); hk.innerHTML='';
        root.querySelector('[data-ez-kindhint]').textContent =
          'You have '+(groupQty()||S.total||0)+' '+S.size+' '+(S.base||'').toLowerCase()+' '+unitFor(groupQty()||S.total||0)+' so far.';
        var same=optionBtn(hk, false, 'Another design',
          'Same bags. Just a different picture on them.');
        same.classList.add('ez-fork-add');
        same.insertAdjacentHTML('afterbegin','<span class="ez-fork-ic" aria-hidden="true">+</span>');
        same.addEventListener('click', function(){
          designs.push(newDesign()); cur=designs.length-1;
          state.mode='design';
          setTimeout(function(){ go('dart'); }, PICK_MS);
        });
        var diff=optionBtn(hk, false, 'Change the bag',
          'A new size, material, or finish. We\u2019ll start you with these settings.');
        diff.classList.add('ez-fork-alt');
        diff.insertAdjacentHTML('afterbegin','<span class="ez-fork-ic" aria-hidden="true">\u29c9</span>');
        diff.addEventListener('click', function(){ setTimeout(function(){ addGroup(false, S); }, PICK_MS); });
      }
      if(id==='review'){ paintReview(); }
      if(id!=='review') disarmDelete();
      if(id==='done'){
        var tot=0, dcount=0, ngroups=groups.length, unit=unitWord();
        if(DONE){
          tot=DONE.tot; dcount=DONE.designs; ngroups=DONE.groups; unit=DONE.unit||unit;
        } else {
          groups.forEach(function(g){ g.designs.forEach(function(x){ tot+=(x.qty||0); dcount++; }); });
        }
        root.querySelector('[data-ez-donetx]').textContent =
          tot+' '+(tot===1?unit.replace(/s$/,''):unit)+' across '+dcount+' design'+(dcount>1?'s':'')+
          (ngroups>1 ? (' and '+ngroups+' bag setups') : '')+' are in your cart.';
        var dn=root.querySelector('[data-ez-donenext]');
        if(dn) dn.hidden = !dn.textContent.trim();
      }
    }
    function setDeltaNote(which){
      var el = root.querySelector('[data-ez-'+which+'note]');
      if(!el) return;
      var q = configQty();
      el.textContent = q ? ('Prices show what each choice adds to all '+q+' '+unitFor(q)+', discount included.') : '';
    }
    function paintSpot(){
      var wrap=root.querySelector('[data-ez-spotwrap]');
      var btn=root.querySelector('[data-ez-spot]');
      var ok = S.base==='Holographic' && !!findVariant('Holographic',S.finish||'',true,S.size,S.sides||'Single');
      wrap.hidden=!ok;
      if(!ok){ S.spot=false; return; }
      btn.classList.toggle('is-on', !!S.spot);
      btn.setAttribute('aria-pressed', S.spot ? 'true' : 'false');
      root.querySelector('[data-ez-spotdiff]').textContent =
        pdiff(priceAt('Holographic',S.finish||'',true), priceAt('Holographic',S.finish||'',false));
    }
    root.querySelector('[data-ez-spot]').addEventListener('click', function(){
      S.spot = !S.spot;
      S.readyAns=null; S.tier=''; S.ready=false;
      paintSpot();
      primary.textContent = primaryLabel();
      paintStepLabel();
    });
    var totInp = root.querySelector('[data-ez-tot]');
    function totMin(){ return Math.max(1, minForSize(S.size) - otherGroupsQty()); }
    function touchTotal(){ S.totalTouched = true; }
    function sweetSpotTotal(){
      var lad = ladderFor(S.size) || [];
      var out = otherGroupsQty();
      var min = totMin();
      var bestMin = null, bestRatio = -1;
      for(var i=1;i<lad.length;i++){
        var t = lad[i], p = lad[i-1];
        if(BULK > 0 && t.min >= BULK) break;
        var gain = (t.pct||0) - (p.pct||0);
        var cost = t.min - p.min;
        if(cost <= 0 || gain <= 0) continue;
        var ratio = gain / cost;
        if(ratio > bestRatio){ bestRatio = ratio; bestMin = t.min; }
      }
      if(bestMin == null) return min;
      return Math.max(min, bestMin - out);
    }
    function paintTotal(fromUser, skipSplit){
      var live = groupQty();
      if(fromUser){
        // skipSplit: called from the per-keystroke input handler, which must NOT
        // re-split — a value in transit ("2" on the way to "256") would clamp the
        // design count down and permanently drop designs 3+ with their artwork.
        // The split runs once on blur/Enter with the committed value.
        if(!skipSplit && live > 0 && live !== S.total) applySplit(designs.length);
      } else if(live > 0){
        S.total = live;
      }
      if(S.total==null || S.total<1) S.total = sweetSpotTotal();
      totInp.value = S.total;
      var out = otherGroupsQty(), m = minForSize(S.size);
      root.querySelector('[data-ez-totq]').textContent = 'How many '+unitWord()+' in total?';
      var sweet = sweetSpotTotal(), sweetPct = pctFor((otherGroupsQty()+sweet), ladderFor(S.size));
      root.querySelector('[data-ez-tothint]').textContent = (!S.totalTouched && S.total===sweet && sweetPct>0)
        ? ('We picked '+sweet+' \u2014 a great deal at '+sweetPct+'% off. Change it to anything you like.')
        : ('At least '+m+'. The more you order, the less each one costs.');
      var cartLine = root.querySelector('[data-ez-totcart]');
      if(cartLine){
        cartLine.hidden = !(out > 0);
        if(out > 0){
          var need = m - out;
          var head = '<b>You already have '+out+' '+shortSize(S.size)+' '+unitFor(out)+' in your cart.</b> ';
          if(need > 0){
            cartLine.innerHTML = head + 'They count too, so you only need '+need+' more.';
          } else {
            cartLine.innerHTML = head + 'You\u2019re past the minimum, so order any amount.';
          }
        }
      }
      var chips = root.querySelector('[data-ez-totchips]'); chips.innerHTML='';
      var lad = ladderFor(S.size);
      var visible = lad.filter(function(t){ return !(BULK>0 && t.min>=BULK); });
      var activeMin = -1;
      visible.forEach(function(t){ if(S.total >= t.min) activeMin = t.min; });
      visible.forEach(function(t){
        var n = t.min;
        var pooled = out + n;
        var pct = pctFor(pooled, lad);
        var b=document.createElement('button'); b.type='button';
        b.className='ez-chip'+(n===activeMin?' is-on':'');
        b.innerHTML=n+(pct>0?('<small>'+pct+'% off</small>'):'<small>minimum</small>');
        b.addEventListener('click', function(){
          var already = (S.total===n);
          S.total=n; touchTotal(); paintTotal(true);
          if(already) setTimeout(advance,180);
        });
        chips.appendChild(b);
      });
      var el=root.querySelector('[data-ez-totprice]');
      var v = variant() || findVariant(S.base||'Matte', S.finish||'', S.spot, S.size, S.sides||'Double');
      if(v){
        var pool=out+S.total, pct=pctFor(pool,ladderFor(S.size));
        var each=Math.round(v.price*(1-pct/100));
        var short=Math.max(0, m-pool);
        el.innerHTML='About <strong>'+money(each)+' per '+unitWord().replace(/s$/,'')+'</strong> \u00b7 <strong>'+money(each*S.total)+'</strong> for '+S.total+'.'+
          (pct>0?'<span class="ez-save">'+pct+'% volume discount already taken off.</span>':'')+
          (out>0?('<br><span class="ez-sub2">Your '+out+' in the cart got you this price.</span>'):'')+
          (short>0?('<br><span class="ez-warn">'+short+' more '+unitFor(short)+' to go before you can order.</span>'):'');
      } else { el.textContent=''; }
      paintRunTotal();
    }
    totInp.addEventListener('input', function(){ var q=parseInt(totInp.value.replace(/[^0-9]/g,''),10); if(!isNaN(q)){ S.total=q; touchTotal(); paintTotal(true, true); } });
    totInp.addEventListener('blur', function(){ var q=parseInt(totInp.value,10); S.total=(isNaN(q)||q<1)?totMin():q; touchTotal(); paintTotal(true); });
    totInp.addEventListener('keydown', function(e){ if(e.key==='Enter') totInp.blur(); });
    function splitEven(total, n){
      var base=Math.floor(total/n), rem=total%n, out=[];
      for(var i=0;i<n;i++) out.push(base + (i<rem ? 1 : 0));
      return out;
    }
    function applySplit(n){
      var total=S.total||groupQty()||1;
      n=Math.max(1, Math.min(n, total));
      var parts=splitEven(total,n);
      var old=designs.slice();
      var next=[];
      for(var i=0;i<n;i++){
        var d = old[i] || newDesign();
        d.qty = parts[i];
        next.push(d);
      }
      groups[gi].designs = next;
      designs = next;
      cur = 0;
    }
    function maxSplit(){ return Math.max(1, Math.min(S.total||1, 20)); }
    function splitSummary(n){
      var total=S.total||1, parts=splitEven(total,n);
      if(n<=4) return parts.join(' + ')+' '+unitWord();
      var lo=Math.min.apply(null,parts), hi=Math.max.apply(null,parts);
      return (lo===hi) ? (lo+' '+unitFor(lo)+' each')
                       : ('about '+hi+' '+unitFor(hi)+' each');
    }
    function paintSplit(){
      var total=S.total||1;
      root.querySelector('[data-ez-splitq]').textContent='How many different designs on these bags?';
      root.querySelector('[data-ez-splithint]').textContent=
        'One design, or a few different ones \u2014 your call. You can change the amounts later.';
      var host=root.querySelector('[data-ez-split]');
      var panel=root.querySelector('[data-ez-splitmore]');
      host.hidden = !!state.splitMore;
      panel.hidden = !state.splitMore;
      if(state.splitMore){ paintSplitMore(); return; }
      host.innerHTML='';
      [1,2,3,4].filter(function(n){ return n<=total; }).forEach(function(n){
        var sub = n===1 ? ('All '+total+' '+unitFor(total)+' with one design') : splitSummary(n);
        var b=optionBtn(host, designs.length===n, n===1 ? 'Just one design' : (n+' designs'), sub);
        b.addEventListener('click', function(){ applySplit(n); mark(host,b); setTimeout(advance,PICK_MS); });
      });
      if(total > 4){
        var more=optionBtn(host, designs.length>4, 'More than 4', 'Pick the exact number.');
        more.addEventListener('click', function(){
          state.splitMore=true;
          if(designs.length<5) applySplit(Math.min(5,total));
          paintSplit(); paintChrome();
        });
      }
    }
    var sCountInp = root.querySelector('[data-ez-scount]');
    function paintSplitMore(){
      var n=Math.max(5, Math.min(designs.length, maxSplit()));
      sCountInp.value=n;
      var total=S.total||1;
      root.querySelector('[data-ez-spreview]').innerHTML =
        '<strong>'+n+' designs</strong> \u00b7 '+splitSummary(n)+
        '<br><span class="ez-sub2">We split your '+total+' '+unitFor(total)+' as evenly as we can.</span>';
    }
    function setSplitCount(n){
      n=Math.max(1, Math.min(n, maxSplit()));
      applySplit(n);
      paintSplitMore();
    }
    sCountInp.addEventListener('input', function(){
      var n=parseInt(sCountInp.value.replace(/[^0-9]/g,''),10);
      if(!isNaN(n) && n>=1) setSplitCount(n);
    });
    sCountInp.addEventListener('blur', function(){ setSplitCount(parseInt(sCountInp.value,10) || 5); });
    sCountInp.addEventListener('keydown', function(e){ if(e.key==='Enter') sCountInp.blur(); });
    function bindSplitBtn(btn, delta){
      var t=null, iv=null;
      function bump(){ if(navBusy) return; setSplitCount(designs.length + delta); }
      function start(e){ if(navBusy) return; e.preventDefault(); bump(); t=setTimeout(function(){ iv=setInterval(bump,140); },450); }
      function stop(){ clearTimeout(t); clearInterval(iv); t=iv=null; }
      holdStops.push(stop);
      btn.addEventListener('touchstart', start, {passive:false});
      btn.addEventListener('touchend', stop); btn.addEventListener('touchcancel', stop);
      btn.addEventListener('mousedown', function(e){ if(e.button===0) start(e); });
      btn.addEventListener('mouseup', stop); btn.addEventListener('mouseleave', stop);
      btn.addEventListener('click', function(e){ if(e.detail===0) bump(); });
    }
    bindSplitBtn(root.querySelector('[data-ez-sminus]'), -1);
    bindSplitBtn(root.querySelector('[data-ez-splus]'), +1);
    root.querySelector('[data-ez-sback]').addEventListener('click', function(){
      state.splitMore=false;
      if(designs.length>4) applySplit(4);
      paintSplit(); paintChrome();
    });
    function clampQty(q){ if(isNaN(q)||q<1) q=1; return q; }
    function paintQty(){
      if(D().qty==null) D().qty=suggestQty();
      qtyInp.value=D().qty;
      var others=othersQty(), m=poolMin(), unit=unitWord();
      root.querySelector('[data-ez-qtyhint]').textContent = others>0
        ? ((others===1 ? 'Your other bag stays as it is.' : ('Your other '+others+' bags stay as they are.')))
        : ('You need '+m+' in total to order.');
      var chips=root.querySelector('[data-ez-qtychips]'); chips.innerHTML='';
      ladderFor(S.size).forEach(function(t){
        if(BULK>0 && t.min>=BULK) return;
        var mine=t.min-others;
        if(mine < 1) return;
        var b=document.createElement('button'); b.type='button';
        b.className='ez-chip'+(D().qty===mine?' is-on':'');
        b.innerHTML=mine+(t.pct>0?('<small>'+t.pct+'% off</small>'):'<small>minimum</small>');
        b.addEventListener('click', function(){ D().qty=mine; paintQty(); });
        chips.appendChild(b);
      });
      paintPrice();
    }
    function paintPrice(){
      var el=root.querySelector('[data-ez-price]');
      var v = variant() || findVariant(S.base||'Matte', S.finish||'', S.spot, S.size, S.sides||'Double');
      if(!v){ el.textContent=''; return; }
      var pool=othersQty()+(D().qty||0);
      var pct=pctFor(pool,ladderFor(S.size));
      var each=Math.round(v.price*(1-pct/100));
      var short=Math.max(0, poolMin()-pool);
      var html='<strong>'+money(each)+' per '+unitWord().replace(/s$/,'')+'</strong> \u00b7 <strong>'+money(each*(D().qty||0))+'</strong> for '+(D().qty||0)+' '+unitFor(D().qty||0)+'.'+
        (pct>0 ? '<span class="ez-save">'+pct+'% volume discount already taken off.</span>' : '');
      if(specialOf(S) || S.base==='Holographic'){
        var plain=findVariant('Matte','',false,S.size,S.sides||'Double');
        if(plain){
          var plainEach=Math.round(plain.price*(1-pct/100));
          var up=(each-plainEach)*(D().qty||0);
          if(up>0) html += '<br><span class="ez-sub2">'+styleDisplay(S)+' adds '+money(up)+' to '+((D().qty||0)===1?'this bag':('these '+(D().qty||0)+' bags'))+'.</span>';
        }
      }
      if(short>0){
        html += '<br><span class="ez-warn">'+short+' more to go before you can order. Add more here, or add another design on the next screen.</span>';
      }
      el.innerHTML=html;
      paintRunTotal();
    }
    qtyInp.addEventListener('input', function(){ var q=parseInt(qtyInp.value.replace(/[^0-9]/g,''),10); if(!isNaN(q)){ D().qty=q; paintPrice(); } });
    qtyInp.addEventListener('blur', function(){
      D().qty=clampQty(parseInt(qtyInp.value,10));
      S.total=groupQty();
      paintQty();
    });
    qtyInp.addEventListener('keydown', function(e){ if(e.key==='Enter'){ qtyInp.blur(); } });
    function bindStep(btn, delta){
      var t=null, iv=null;
      function bump(){ if(navBusy) return; D().qty=clampQty((D().qty||suggestQty())+delta); paintQty(); }
      function start(e){ if(navBusy) return; e.preventDefault(); bump(); t=setTimeout(function(){ iv=setInterval(bump,90); },450); }
      function stop(){ clearTimeout(t); clearInterval(iv); t=iv=null; }
      holdStops.push(stop);
      btn.addEventListener('touchstart', start, {passive:false});
      btn.addEventListener('touchend', stop); btn.addEventListener('touchcancel', stop);
      btn.addEventListener('mousedown', function(e){ if(e.button===0) start(e); });
      btn.addEventListener('mouseup', stop); btn.addEventListener('mouseleave', stop);
      btn.addEventListener('click', function(e){ if(e.detail===0) bump(); });
    }
    bindStep(root.querySelector('[data-ez-minus]'), -1);
    bindStep(root.querySelector('[data-ez-plus]'), +1);
    function bindTot(btn, delta){
      var t=null, iv=null;
      function bump(){ if(navBusy) return; S.total=Math.max(1,(S.total||totMin())+delta); touchTotal(); paintTotal(true); }
      function start(e){ if(navBusy) return; e.preventDefault(); bump(); t=setTimeout(function(){ iv=setInterval(bump,90); },450); }
      function stop(){ clearTimeout(t); clearInterval(iv); t=iv=null; }
      holdStops.push(stop);
      btn.addEventListener('touchstart', start, {passive:false});
      btn.addEventListener('touchend', stop); btn.addEventListener('touchcancel', stop);
      btn.addEventListener('mousedown', function(e){ if(e.button===0) start(e); });
      btn.addEventListener('mouseup', stop); btn.addEventListener('mouseleave', stop);
      btn.addEventListener('click', function(e){ if(e.detail===0) bump(); });
    }
    bindTot(root.querySelector('[data-ez-tminus]'), -1);
    bindTot(root.querySelector('[data-ez-tplus]'), +1);
    root.querySelector('[data-ez-lower]').addEventListener('click', function(){
      S.total=Math.max(1, BULK-1); go('gtotal');
    });
    function isPreviewable(name){
      return /\.(png|jpe?g|gif|webp|avif|bmp|svg)$/i.test(name||'');
    }
    function fileKind(name){
      var m=/\.([a-z0-9]+)$/i.exec(name||'');
      return m ? m[1].toUpperCase() : 'FILE';
    }
    function prettySize(b){
      if(!b && b!==0) return '';
      return b < 1048576 ? (Math.max(1, Math.round(b/1024))+' KB')
                         : ((b/1048576).toFixed(b/1048576 < 10 ? 1 : 0)+' MB');
    }
    function previewURL(f){
      if(!f) return '';
      if(f.kept)  return isPreviewable(f.name) ? f.url : '';
      if(f.file && isPreviewable(f.name)){
        if(!f.preview){ try{ f.preview = URL.createObjectURL(f.file); }catch(e){ f.preview=''; } }
        return f.preview || '';
      }
      return '';
    }
    function dropPreview(f){
      if(!f) return '';
      var url = previewURL(f);
      if(url) return '<span class="ez-thumb"><img src="'+esc(url)+'" alt=""></span>';
      return '<span class="ez-thumb ez-thumb-doc"><b>'+esc(fileKind(f.name))+'</b></span>';
    }
    function dropFree(f){
      if(f && f.preview){ try{ URL.revokeObjectURL(f.preview); }catch(e){} f.preview=null; }
    }
    function afterShow(id){
      if(id === 'dcolor') requestAnimationFrame(fitColorGrid);
    }
    function fitColorGrid(){
      var step = steps['dcolor']; if(!step) return;
      var h7 = step.querySelector('[data-ez-colors]'); if(!h7) return;
      var n = colorsFor(S.size, S.base).length;
      if(!n) return;
      var cols = (getComputedStyle(h7).gridTemplateColumns||'').split(/\s+/).filter(Boolean).length || 4;
      var ns   = h7.querySelector('.ez-sw.is-any');
      var rem  = n % cols;
      var span = rem === 0 ? cols : (cols - rem);
      if(span < 2) span = cols;
      // "Not sure, match my art" needs ~135px of label; below ~210px of tile the
      // 1-line clamp cut it to "Not sure,…" (a 2-of-5-column slot at 375px is
      // ~118px). If the remainder slot is too narrow, give it its own full row.
      if(span * (h7.clientWidth / cols) < 210) span = cols;
      if(ns){
        ns.style.gridColumn = 'span ' + span;
        ns.classList.toggle('is-wide', span >= 2);
      }
      var rows = Math.ceil(n / cols) + (span === cols ? 1 : 0);
      var avail = stage.clientHeight;
      Array.prototype.forEach.call(step.children, function(el){
        if(el !== h7 && !el.hidden) avail -= el.offsetHeight
          + parseFloat(getComputedStyle(el).marginTop || 0)
          + parseFloat(getComputedStyle(el).marginBottom || 0);
      });
      var gap = parseFloat(getComputedStyle(h7).rowGap || 8) || 8;
      avail -= 6;
      var tile = Math.floor((avail - (rows - 1) * gap) / rows);
      tile = Math.min(92, tile);
      /* 48, not 46: a tight tile spends 3 border + 14 padding + 5 gap + 12 label
          line = 34px before the dot exists, and the dot floors at 16 — below 48
          the LABEL paid the difference and clipped mid-line ("Baby" for
          "Baby Blue/Sky Blue"; found on-device 2026-08-05). The dot formula caps
          at tile-34 for the same reason: the swatch shrinks, the words never do. */
      var MIN = 48;
      for(var guard = 0; guard < 24; guard++){
        var oneLine = tile < 70;
        h7.classList.toggle('is-tight', oneLine);
        h7.style.setProperty('--ez-tile', Math.max(MIN, tile) + 'px');
        h7.style.setProperty('--ez-dot',
          Math.round(Math.max(16, Math.min(32, oneLine ? Math.min(tile * 0.44, tile - 34) : tile * 0.36))) + 'px');
        if(tile <= MIN) break;
        if(stage.scrollHeight <= stage.clientHeight + 1) break;
        tile -= 4;
      }
    }
    function paintDrop(side){
      var host=root.querySelector('[data-ez-drop="'+side+'"]'); if(!host) return;
      var f=D()[side], inner;
      if(f && f.lost){
        inner='<span class="ez-drop-h">Add this file again</span>'+
          '<span class="ez-drop-file is-lost">'+esc(f.name)+'</span>'+
          '<span class="ez-drop-s">The reload dropped it. Everything else was saved.</span>';
      } else if(f && f.later){
        inner='<span class="ez-drop-badge">\u2709</span>'+
          '<span class="ez-drop-h">You\u2019ll send this after checkout</span>'+
          '<span class="ez-drop-s">By text or Instagram DM. Tap to upload now instead.</span>'+
          '<button type="button" class="ez-drop-x" data-ez-uploadnow>Upload it now</button>';
      } else if(f){
        var meta = [prettySize(f.file && f.file.size)].filter(Boolean).join('');
        inner=dropPreview(f)+
          '<span class="ez-drop-file">'+esc(f.name)+'</span>'+
          (meta ? '<span class="ez-drop-meta">'+esc(meta)+'</span>' : '')+
          (f.kept
            ? '<span class="ez-drop-s">Already uploaded. Tap to replace.</span>'
            : (f.oversize
              ? '<span class="ez-drop-s">Too big to upload. We\u2019ll collect it after checkout.</span>'
              : '<span class="ez-drop-s">Is this the right artwork? Tap to swap.</span>'))+
          '<button type="button" class="ez-drop-x" data-ez-clear>Remove</button>';
      } else {
        inner='<span class="ez-drop-h">Tap to upload</span>'+
          '<span class="ez-drop-s">PNG, JPG, PDF or AI</span>';
      }
      var copyLink = '';
      if(side==='back' && !f && D().front && D().front.file){
        copyLink = '<button type="button" class="ez-copyfront-btn" data-ez-copyfront>'+
                   '<span class="ez-copyfront-ic" aria-hidden="true">\u21a9</span>'+
                   '<span>Use same as front</span></button>';
      }
      /*
        A role=button DIV, not a <label>. Native label->input forwarding is
        unreliable here: the nested Remove button becomes the label's implicit
        control, so tapping the box fired Remove (deleting the artwork) and never
        opened the picker — the reported "dead clicks". The full builder already
        drives the picker explicitly (custom-bag-builder-multi.liquid:1506); this
        mirrors it: click/Enter/Space and drag-drop all call input.click().
      */
      host.innerHTML='<div class="ez-drop'+(f && !f.lost && !f.later?' has-file':'')+(f && f.lost?' is-lost':'')+(f && f.later?' is-later':'')+'" role="button" tabindex="0" aria-label="Upload '+side+' artwork">'+inner+'<input type="file" data-ez-file accept="image/*,.pdf,.ai,.eps,.psd,.tif,.tiff"></div>'+copyLink;
      var drop=host.querySelector('.ez-drop');
      var input=host.querySelector('[data-ez-file]');
      function openPicker(){ showOpening(drop); input.click(); }
      drop.addEventListener('click', function(e){
        // the Remove button clears and handles its own click; everything else
        // (including the "Upload it now" button) opens the picker
        if(e.target.closest('[data-ez-clear]')) return;
        if(e.target.closest('[data-ez-copyfront]')) return;
        openPicker();
      });
      drop.addEventListener('keydown', function(e){
        if(e.key==='Enter' || e.key===' '){ e.preventDefault(); openPicker(); }
      });
      ['dragenter','dragover'].forEach(function(ev){ drop.addEventListener(ev, function(e){ e.preventDefault(); drop.classList.add('is-drag'); }); });
      ['dragleave','dragend'].forEach(function(ev){ drop.addEventListener(ev, function(){ drop.classList.remove('is-drag'); }); });
      drop.addEventListener('drop', function(e){
        e.preventDefault(); drop.classList.remove('is-drag');
        var dropped=e.dataTransfer && e.dataTransfer.files;
        if(dropped && dropped[0]){ input.files=dropped; input.dispatchEvent(new Event('change')); }
      });
      input.addEventListener('change', function(){
        var file=input.files && input.files[0]; if(!file) return;
        /* one place to raise a file complaint on this step */
        function showFileErr(msg){
          input.value='';
          var stepEl=steps[state.step];
          var fe0=stepEl && stepEl.querySelector('[data-ez-fileerr]');
          if(!fe0 && stepEl){
            fe0=document.createElement('p'); fe0.className='ez-fielderr'; fe0.setAttribute('data-ez-fileerr','');
            fe0.setAttribute('role','alert');
            var grid0=stepEl.querySelector('[data-ez-artgrid]');
            if(grid0 && grid0.parentNode) grid0.parentNode.insertBefore(fe0, grid0.nextSibling);
            else stepEl.appendChild(fe0);
          }
          if(fe0){ fe0.hidden=false; fe0.textContent=msg; }
          flash(drop);
        }
        /* A ZERO-BYTE PICK (2026-09-17, the hole fixed on the vial page the same day):
           an iCloud/Drive file that has not downloaded to the device arrives as a
           File with size 0. (A file moved or deleted AFTER a good pick is a
           different failure: its size still reads fine and the add itself rejects.) It is TRUTHY, so it used to ride the add as real artwork and
           Shopify stored an EMPTY property \u2014 no file for the floor AND no
           "send after checkout" note either. Found on #1131's KLOW row. */
        if(!file.size){ showFileErr('That file came through empty \u2014 it may still be downloading from iCloud or Drive. Open it once on this device, then pick it again.'); return; }
        /* drag-and-drop bypassed the picker's accept= filter entirely — any
           file type landed as artwork (audit 2026-08-24). Gate BEFORE
           dropFree so a rejected drop never destroys accepted artwork. */
        if(!(/^image\//i.test(file.type) || isPreviewable(file.name) || /\.(pdf|ai|eps|psd|tiff?)$/i.test(file.name||''))){
          showFileErr('That file type won\u2019t print. Send PNG, JPG, PDF, AI, EPS, PSD or TIFF \u2014 or choose Send after checkout.');
          return;
        }
        dropFree(D()[side]);
        D()[side] = file.size>MAXBYTES
          ? {oversize:true, file:file, name:file.name}
          : {file:file, name:file.name};
        if(file.size<=MAXBYTES) idbSaveFile(D().id, side, D()[side]);
        else idbDelKey(artKey(D().id, side)).catch(function(){});
        var fe=steps[state.step] && steps[state.step].querySelector('[data-ez-fileerr]');
        if(fe) fe.hidden=true;
        paintDrop(side);
        if(side==='front' && S.sides==='Double' && !D().back) paintDrop('back');
        paintLaterLink();
        saveSoon();
      });
      var clr=host.querySelector('[data-ez-clear]');
      if(clr) clr.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        dropFree(D()[side]);
        idbDelKey(artKey(D().id, side)).catch(function(){});
        D()[side]=null; paintDrop(side);
        if(side==='front' && S.sides==='Double' && !D().back) paintDrop('back');
        if(side==='back') paintDrop('back');
        paintLaterLink(); saveSoon();
      });
    }
    function paintLaterLink(side){
      var wrap = root.querySelector('[data-ez-laterwrap-front]');
      if(!wrap) return;
      function answered(s){ var f=D()[s]; return !!(f && (f.file || f.kept || f.oversize || f.later)); }
      var needBack = S.sides==='Double';
      var allDone = answered('front') && (!needBack || answered('back'));
      var anyDeferred = (D().front && D().front.later) || (needBack && D().back && D().back.later);
      wrap.hidden = allDone || anyDeferred;
    }
    /* QR opt-in. Two mutually exclusive inputs on the design: d.qr (a
        file slot shaped exactly like front/back, so fileMeta/appendArt/idb all work
        unchanged) and d.qrLink ("instagram.com/<handle>" — the team generates the QR
        at print). Entering one clears the other; neither ever gates Continue. */
    function normIg(v){
      v=String(v||'').trim();
      if(!v) return '';
      v=v.replace(/^@+/,'').replace(/^https?:\/\//i,'').replace(/^www\./i,'')
         .replace(/^instagram\.com\//i,'').replace(/\/+$/,'');
      return v ? 'instagram.com/'+v : '';
    }
    function qrSummary(d){
      /* just the handle — the row label already says "QR code",
          and the prefix was what truncated it on phones */
      if(d.qrLink) return '@'+d.qrLink.replace(/^instagram\.com\//,'');
      var f=d.qr;
      if(!f) return '';
      if(f.lost) return (f.name||'your file')+' — add it again';
      if(f.oversize) return f.name+' (we’ll collect it)';
      return f.name||'your file';
    }
    function paintQr(resetOpen){
      var wrap=root.querySelector('[data-ez-qrwrap]');
      if(!wrap) return;
      var d=D();
      var hasData=!!(d.qr || (d.qrLink||'').trim());
      if(resetOpen){
        wrap.dataset.open = hasData ? '1' : '0';
        wrap.dataset.mode = d.qrLink ? 'link' : 'file';
      }
      var open = wrap.dataset.open==='1';
      var mode = wrap.dataset.mode || (d.qrLink ? 'link' : 'file');
      var body=wrap.querySelector('[data-ez-qrbody]');
      var tg=wrap.querySelector('[data-ez-qrtoggle]');
      body.hidden=!open;
      wrap.classList.toggle('is-open', open);
      tg.setAttribute('aria-expanded', open?'true':'false');
      wrap.querySelector('[data-ez-qrstate]').textContent = hasData ? '✓ Added' : '';
      wrap.querySelectorAll('[data-ez-qrmode]').forEach(function(b){
        var on = b.getAttribute('data-ez-qrmode')===mode;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on?'true':'false');
      });
      wrap.querySelectorAll('[data-ez-qrpane]').forEach(function(p){
        p.hidden = p.getAttribute('data-ez-qrpane')!==mode;
      });
      var nameEl=wrap.querySelector('[data-ez-qrname]');
      var clearBtn=wrap.querySelector('[data-ez-qrclear]');
      var ctaEl=wrap.querySelector('[data-ez-qrcta]');
      nameEl.textContent = d.qr ? qrSummary({qr:d.qr, qrLink:''}) : '';
      if(ctaEl) ctaEl.hidden = !!d.qr;
      clearBtn.hidden = !d.qr;
      var linkInp=wrap.querySelector('[data-ez-qrlink]');
      if(document.activeElement!==linkInp){
        linkInp.value = (d.qrLink||'').replace(/^instagram\.com\//,'');
      }
      if(!wrap.dataset.bound){
        wrap.dataset.bound='1';
        tg.addEventListener('click', function(){
          wrap.dataset.open = wrap.dataset.open==='1' ? '0' : '1';
          paintQr();
          if(wrap.dataset.open==='1' && wrap.dataset.mode==='link'){
            var li=wrap.querySelector('[data-ez-qrlink]');
            if(li && !li.value) li.focus();
          }
        });
        wrap.querySelectorAll('[data-ez-qrmode]').forEach(function(b){
          b.addEventListener('click', function(){
            wrap.dataset.mode=b.getAttribute('data-ez-qrmode');
            paintQr();
            if(wrap.dataset.mode==='link'){
              var li=wrap.querySelector('[data-ez-qrlink]');
              if(li && !li.value) li.focus();
            }
          });
        });
        // tapping anywhere on the field (incl. the @ prefix) focuses the input
        var igWrap=wrap.querySelector('.ez-qrig');
        if(igWrap) igWrap.addEventListener('click', function(){ linkInp.focus(); });
        /* The artwork dropzone got showOpening() on 07-28; this zone didn't.
            Opening the OS file sheet mutates nothing in-page, so QR taps read
            as dead (and rage) in Clarity. Same instant overlay as .ez-drop. */
        var qrDropEl=wrap.querySelector('.ez-qrdrop');
        if(qrDropEl) qrDropEl.addEventListener('click', function(){ showOpening(qrDropEl); });
        var fileInp=wrap.querySelector('[data-ez-qrfile]');
        fileInp.addEventListener('change', function(){
          var file=fileInp.files && fileInp.files[0];
          fileInp.value='';
          if(!file) return;
          // zero-byte pick — see the artwork guard above; never let it become a property
          if(!file.size){ emptyPick(qrDropEl, true); return; }
          emptyPick(qrDropEl, false);
          var d2=D();
          d2.qrLink='';
          if(file.size > MAXBYTES){
            /* Same contract as artwork: accepted as a placeholder, the
                property becomes a PENDING string, never blocks the order. */
            d2.qr={oversize:true, file:file, name:file.name};
            idbDelKey(artKey(d2.id,'qr')).catch(function(){});
          } else {
            d2.qr={file:file, name:file.name};
            idbSaveFile(d2.id, 'qr', d2.qr);
          }
          paintQr(); saveSoon();
        });
        clearBtn.addEventListener('click', function(){
          var d2=D();
          idbDelKey(artKey(d2.id,'qr')).catch(function(){});
          d2.qr=null;
          if(EDIT) EDIT.qr='';
          paintQr(); saveSoon();
        });
        linkInp.addEventListener('input', function(){
          var d2=D();
          d2.qrLink = normIg(linkInp.value);
          if(d2.qrLink && d2.qr){
            idbDelKey(artKey(d2.id,'qr')).catch(function(){});
            d2.qr=null;
            nameEl.textContent='';
            clearBtn.hidden=true;
            var ce=wrap.querySelector('[data-ez-qrcta]'); if(ce) ce.hidden=false;
          }
          if(EDIT && !d2.qrLink) EDIT.qr='';
          saveSoon();
        });
      }
    }
    root.addEventListener('click', function(e){
      var lb = e.target.closest && e.target.closest('[data-ez-later]');
      if(!lb) return;
      e.preventDefault();
      var sides = (S.sides==='Double') ? ['front','back'] : ['front'];
      sides.forEach(function(side){
        /* Never clobber a slot that already holds artwork. `.file` is a fresh
            upload; `.kept` is a file already on the cart line (edit-from-cart seeds those,
            and they have no .file). Checking only .file meant a buyer deferring a MISSING
            back also threw away an already-uploaded front — and the idbDelKey below
            deleted its stored copy. */
        if(D()[side] && (D()[side].file || D()[side].kept)) return;
        dropFree(D()[side]);
        idbDelKey(artKey(D().id, side)).catch(function(){});
        D()[side] = {later:true};
        paintDrop(side);
      });
      var fe = steps[state.step] && steps[state.step].querySelector('[data-ez-fileerr]');
      if(fe) fe.hidden=true;
      paintLaterLink();
      saveSoon();
      setTimeout(function(){ if(state.step==='dart') advance(); }, 200);
    });
    root.addEventListener('click', function(e){
      var cb = e.target.closest && e.target.closest('[data-ez-copyfront]');
      if(!cb) return;
      e.preventDefault(); e.stopPropagation();
      var f=D().front;
      if(f && f.file){
        dropFree(D().back);
        D().back = f.oversize ? {oversize:true, file:f.file, name:f.name}
                              : {file:f.file, name:f.name};
        if(!f.oversize) idbSaveFile(D().id, 'back', D().back);
        paintDrop('back');
        /* Clear the "we need your back artwork" error — the back slot is filled
            now. The send-it-later handler already does this; copy-front did not, so the
            error sat there contradicting the thumbnail right above it. */
        var fe = steps[state.step] && steps[state.step].querySelector('[data-ez-fileerr]');
        if(fe) fe.hidden = true;
        paintLaterLink();
      }
    });
    function editFrom(step, groupIdx, designIdx){
      useGroup(typeof groupIdx==='number' ? groupIdx : gi, designIdx);
      /* Snapshot a FINISHED group before letting the buyer edit it, so
          backing out restores it instead of destroying it (prev() explains why). Only
          finished groups get one — a genuine draft must still be droppable. */
      state.undo = groupDone(groups[gi])
        ? { gi: gi, size: S.size, total: S.total, totalTouched: S.totalTouched,
            qtys: designs.map(function(d){ return d.qty; }) }
        : null;
      state.mode = (step==='dqty' || cur > 0) ? 'design' : 'config';
      state.ret='review';
      go(step);
    }
    function bindQtyHold(btn, delta, d, g, valEl){
      var t=null, iv=null;
      function bump(){
        if(navBusy) return;
        d.qty = Math.max(1, (d.qty||1) + delta);
        g.S.total = groupTotalOf(g);
        if('value' in valEl) valEl.value = String(d.qty);
        else valEl.textContent = String(d.qty);
        refreshTotals();
        paintRunTotal();
        saveSoon();
      }
      function start(e){ if(navBusy) return; e.preventDefault(); bump(); t=setTimeout(function(){ iv=setInterval(bump,90); },450); }
      function stop(){ clearTimeout(t); clearInterval(iv); t=iv=null; }
      reviewHolds.push(stop);
      btn.addEventListener('touchstart', start, {passive:false});
      btn.addEventListener('touchend', stop); btn.addEventListener('touchcancel', stop);
      btn.addEventListener('mousedown', function(e){ if(e.button===0) start(e); });
      btn.addEventListener('mouseup', stop); btn.addEventListener('mouseleave', stop);
      btn.addEventListener('click', function(e){ if(e.detail===0) bump(); });
    }
    function artLabel(f){
      if(!f) return 'Missing, add it';
      if(f.lost) return 'Add it again';
      if(f.later) return 'Sending later';
      if(f.oversize) return f.name+' (we\u2019ll collect it)';
      return f.name;
    }
    function artSummary(g, d){
      if(g.S.sides!=='Double') return artLabel(d.front);
      if(d.front && d.front.later && d.back && d.back.later) return 'Sending both later';
      /* copy-front makes front and back the same file — "name + name"
          repeated the filename and truncated; say it once */
      var fReal = d.front && (d.front.file || d.front.kept) && d.front.name;
      var bReal = d.back && (d.back.file || d.back.kept) && d.back.name;
      /* lead with "Both sides" so end-truncation eats the filename
          tail, not the information */
      if(fReal && bReal && d.front.name === d.back.name) return 'Both sides · '+d.front.name;
      return artLabel(d.front)+' + '+artLabel(d.back);
    }
    function artPending(f){ return !f || f.oversize || f.later || f.lost; }
    function artLost(f){ return !!(f && f.lost); }
    function designLost(g, d){
      var frontBad = artLost(d.front) || !d.front;
      var backBad  = g.S.sides==='Double' && (artLost(d.back) || !d.back);
      return frontBad || backBad;
    }
    function contactReason(){
      var over=false, later=false;
      groups.forEach(function(g){
        g.designs.forEach(function(d){
          ['front','back'].forEach(function(side){
            if(side==='back' && g.S.sides!=='Double') return;
            var f=d[side];
            if(f && f.oversize) over=true;
            if(f && f.later) later=true;
          });
        });
      });
      if(over && later) return 'Some art is coming after checkout, so we need a way to reach you.';
      if(over)  return 'Your file was too big to upload, so we need a way to collect it.';
      if(later) return 'You\u2019re sending your art after checkout, so we need a way to reach you.';
      return '';
    }
    function needsContact(){
      function chase(f){ return !!(f && (f.oversize || f.later)); }
      var need=false;
      groups.forEach(function(g){
        g.designs.forEach(function(d){
          if(chase(d.front)) need=true;
          if(g.S.sides==='Double' && chase(d.back)) need=true;
        });
      });
      return need;
    }
    function orderTotals(){
      var bags=0, fee=0, count=0, pct=0, pctLo=null, bad=false;
      groups.forEach(function(g){
        var v=findVariant(g.S.base, g.S.finish||'', g.S.spot, g.S.size, g.S.sides||'Double');
        var qty=groupTotalOf(g) || g.S.total || 0;
        if(!g.S.size || !qty) return;
        if(!v){ bad=true; return; }
        var p=pctFor(sumSize(g.S.size,-1,-1) || qty, ladderFor(g.S.size));
        pct=Math.max(pct,p);
        pctLo=(pctLo==null)?p:Math.min(pctLo,p);
        var each=Math.round(v.price*(1-p/100));
        bags += each*qty;
        count += qty;
        // per design, through the waiver judge: a reordered design keeps its paid prep
        g.designs.forEach(function(d){ var fs=feeStateFor(g,d); if(fs.fee) fee += fs.fee.price; });
      });
      return {bags:bags, fee:fee, count:count, pct:pct, pctMixed:(pctLo!=null && pctLo!==pct), total:bags+fee, bad:bad};
    }
    var DESIGN_STEPS={dart:1, dcolor:1, dqty:1};
    function paintBadge(){
      var wrap=root.querySelector('[data-ez-dbadge]');
      if(!wrap) return;
      var show = !!DESIGN_STEPS[state.step] && (designs.length>1 || groups.length>1);
      wrap.hidden=!show;
      if(!show) return;
      var dots=root.querySelector('[data-ez-dots]');
      dots.innerHTML='';
      designs.forEach(function(d,i){
        var s=document.createElement('i');
        s.className='ez-dot'+(i===cur?' is-now':(i<cur?' is-done':''));
        dots.appendChild(s);
      });
      var txt='';
      if(groups.length>1) txt += 'Bag '+(gi+1)+' \u00b7 ';
      txt += 'Design '+(cur+1)+' of '+designs.length;
      var nm=(D().flavor||'').trim();
      if(nm) txt += ' \u00b7 ' + nm;
      root.querySelector('[data-ez-dlabel]').textContent=txt;
    }
    var NO_TOTAL={intro:1, product:1, size:1, quote:1, bulk:1, done:1};
    function hasOrder(){ return groups.some(groupDone); }
    /*
      Is there a finished design ANYWHERE worth jumping back to?

      hasOrder() is deliberately strict — groupDone() requires EVERY design in a
      group to be finished — which is right for "can this be ordered", but wrong
      for "can the buyer get back to their order". The moment you add a second
      design (or start a second bag) to an otherwise-complete order, the group
      now holds one unfinished design, hasOrder() flips false, and the run-total
      escape hatch went dead at exactly the point the buyer might want to bail —
      leaving them to finish a whole second setup just to see the first one.

      Jumping back is safe because paintReview() calls pruneDrafts(), which drops
      unfinished designs and keeps the completed ones, so the half-built thing
      the buyer abandoned never reaches the review screen.
    */
    function hasReviewable(){
      return groups.some(function(g){
        return !!g.S.size && !!g.S.sides && feeAnswered(g.S, g) && g.designs.some(designDone);
      });
    }
    function paintRunTotal(){
      var el=root.querySelector('[data-ez-runtot]');
      if(!el) return;
      var t=orderTotals();
      var show = (!NO_TOTAL[state.step] || hasReviewable()) && t.count>0 && !t.bad;
      el.hidden=!show;
      if(!show) return;
      var jumpable = state.seenReview && hasReviewable() && state.step!=='review';
      if(el.classList.contains('is-armed')){
        el.textContent='Tap again to leave this design';
        el.classList.toggle('is-tappable', jumpable);
        el.disabled = !jumpable;
        return;
      }
      el.innerHTML = t.count+' '+unitFor(t.count)+' \u00b7 <strong>'+money(t.total)+'</strong>' +
                     (jumpable ? '<span class="ez-runchev">\u203a</span>' : '');
      el.classList.toggle('is-tappable', jumpable);
      el.disabled = !jumpable;
      el.setAttribute('aria-label', jumpable ? 'See my order' : 'Order total');
    }
    var errTargets = {lost:[], short:{}, contact:null, fee:[], color:{}};
    var stickyErr   = root.querySelector('[data-ez-stickyerr]');
    var stickyErrTx = root.querySelector('[data-ez-stickyerrtx]');
    var errJumpTo = null;
    var footEl = root.querySelector('.ez-foot');
    function setStickyErr(msg, target){
      if(!stickyErr) return;
      var show = !!msg && state.step==='review';
      stickyErr.hidden = !show;
      if(footEl) footEl.classList.toggle('has-err', show);
      if(!show){ errJumpTo=null; return; }
      stickyErrTx.textContent = msg;
      errJumpTo = target || null;
      stickyErr.classList.toggle('has-target', !!target);
    }
    /* A zero-byte pick has to SAY so wherever it is refused. The artwork step had
       its message; the QR and review pickers only flashed, which reads as the tap
       doing nothing (audit 2026-09-18). One line under the picker, gone on the
       next good pick. */
    var EMPTY_PICK='That file came through empty — it may still be downloading from iCloud or Drive. Open it once on this device, then pick it again.';
    function emptyPick(anchor, show){
      if(!anchor || !anchor.parentNode) return;
      /* the line goes UNDER the picker: inside a flex row (the QR drop sits in one
         beside its clear button) it would become a column and crush the drop */
      var host=anchor, par=anchor.parentNode, cs=window.getComputedStyle(par);
      if(/flex/.test(cs.display) && !/column/.test(cs.flexDirection) && par.parentNode) host=par;
      var p=host.nextElementSibling;
      if(!p || !p.hasAttribute('data-ez-emptyerr')) p=null;
      if(!show){ if(p) p.hidden=true; return; }
      if(!p){
        p=document.createElement('p'); p.className='ez-fielderr'; p.setAttribute('data-ez-emptyerr',''); p.setAttribute('role','alert');
        host.parentNode.insertBefore(p, host.nextSibling);
      }
      p.textContent=EMPTY_PICK; p.hidden=false;
      flash(anchor);
    }
    function flash(el){
      if(!el) return;
      el.classList.remove('is-flash');
      void el.offsetWidth;
      el.classList.add('is-flash');
      setTimeout(function(){ el.classList.remove('is-flash'); }, 1600);
    }
    function shake(el){
      if(!el) return;
      el.classList.remove('is-shake');
      void el.offsetWidth;
      el.classList.add('is-shake');
      setTimeout(function(){ el.classList.remove('is-shake'); }, 520);
    }
    /*
      Blocked-CTA feedback that lands where the thumb already is. The existing
      error lines + is-flash ring all sit ~280px above the footer CTA, so on a
      phone a blocked Continue changed no pixel the buyer could see (349 dead
      clicks on "Continue" in the Jul 27–Aug 6 Clarity window).
    */
    var ctaErr=null, ctaErrT=null;
    function ctaNudge(msg){
      shake(primary);
      if(!footEl || !msg) return;
      if(!ctaErr){
        ctaErr=document.createElement('p');
        ctaErr.className='ez-ctaerr';
        ctaErr.setAttribute('role','status');
        footEl.insertBefore(ctaErr, footEl.firstChild);
      }
      ctaErr.textContent=msg;
      ctaErr.hidden=false;
      clearTimeout(ctaErrT);
      ctaErrT=setTimeout(function(){ if(ctaErr) ctaErr.hidden=true; }, 3600);
    }
    function hideCtaNudge(){ if(ctaErr) ctaErr.hidden=true; clearTimeout(ctaErrT); }
    /* A tap on the ghosted CTA (or a swallowed advance on the tier step): point
        the buyer at the options that actually move the step forward. */
    function nudgeStepOptions(){
      var pane=steps[state.step];
      var opts=pane && (pane.querySelector('.ez-opts') || pane);
      if(opts){
        try{ opts.scrollIntoView({behavior:'smooth', block:'center'}); }
        catch(e){ try{ opts.scrollIntoView(); }catch(e2){} }
        flash(opts);
      }
      ctaNudge('Pick an option above to continue.');
    }
    if(stickyErr) stickyErr.addEventListener('click', function(){
      if(!errJumpTo) return;
      try{ errJumpTo.scrollIntoView({behavior:'smooth', block:'center'}); }
      catch(e){ errJumpTo.scrollIntoView(); }
      flash(errJumpTo);
      var focusable = errJumpTo.matches('input') ? errJumpTo : errJumpTo.querySelector('input,button');
      if(focusable) setTimeout(function(){ try{ focusable.focus({preventScroll:true}); }catch(e){} }, 420);
    });
    function refreshTotals(){
      var tEl=root.querySelector('[data-ez-total]'), err=root.querySelector('[data-ez-err]');
      var lab=root.querySelector('[data-ez-contactlab]'), chint=root.querySelector('[data-ez-contacthint]');
      var cin=root.querySelector('[data-ez-contact]');
      var cerr=root.querySelector('[data-ez-contacterr]');
      err.hidden=true; cerr.hidden=true;
      var mustContact=needsContact(), hasContact=!!(contact||'').trim();
      lab.textContent = mustContact ? 'Where can we reach you? (needed)' : 'Where can we reach you? (optional)';
      chint.textContent = mustContact ? contactReason() : '';
      chint.hidden = !mustContact;
      cin.classList.toggle('is-required', mustContact && !hasContact);
      var t=orderTotals();
      var bad=t.bad, grand=t.bags, feeGrand=t.fee, bagCount=t.count, anyPct=t.pct;
      if(bad){
        tEl.textContent='';
        setStickyErr('That mix of options isn\u2019t available.', null);
        primary.disabled=true; return;
      }
      var inCart=0, seen={};
      groups.forEach(function(g){ if(g.S.size && !seen[g.S.size]){ seen[g.S.size]=1; inCart += cartQty(g.S.size); } });
      tEl.innerHTML='<strong>'+money(grand+feeGrand)+'</strong> \u00b7 '+bagCount+' '+unitFor(bagCount)+
        (feeGrand?(' + '+money(feeGrand)+' spot gloss file edits'):'')+
        (inCart>0?('<br><span class="ez-sub2">Plus '+inCart+' already in your cart. They count toward the same minimum.</span>'):'')+
        (anyPct>0?('<span class="ez-save">'+(t.pctMixed?('Volume discounts up to '+anyPct+'% already taken off.'):(anyPct+'% volume discount already taken off.'))+'</span>'):'');
        /* mixed sizes discount on different curves — claiming the MAX flat
           overstated the money line (audit 2026-08-24) */
      var unanswered=null;
      groups.forEach(function(g){ if(!unanswered && !feeAnswered(g.S, g)) unanswered=g; });
      if(unanswered){
        setStickyErr('Tell us if your file is built for '+styleDisplay(unanswered.S)+'.', errTargets.fee[0]);
        primary.disabled=true; return;
      }
      var lostCount=0;
      groups.forEach(function(g){ g.designs.forEach(function(d){
        if(designLost(g,d)) lostCount++;
      }); });
      if(lostCount){
        setStickyErr(lostCount+' design'+(lostCount>1?'s':'')+' still need'+(lostCount>1?'':'s')+' artwork.',
                     errTargets.lost[0]);
        primary.disabled=true;
        return;
      }
      var short=shortages();
      if(short.length){
        var s0=short[0];
        var msg = (short.length===1)
          ? ('Add '+s0.need+' more '+shortSize(s0.size)+' '+unitFor(s0.need)+'. The minimum is '+s0.min+'.')
          : ('You\u2019re under the minimum on '+short.length+' sizes.');
        setStickyErr(msg, errTargets.short[s0.size]);
        primary.disabled=true; return;
      }
      var noColor=null;
      groups.forEach(function(g){ g.designs.forEach(function(d){
        if(!noColor && !d.color) noColor={g:g, d:d};
      }); });
      if(noColor){
        setStickyErr('Pick a bag color for '+(noColor.d.flavor||'your design')+'.',
                     errTargets.color[noColor.d.id] || null);
        primary.disabled=true; return;
      }
      if(mustContact && !hasContact){
        cerr.hidden=false;
        cerr.textContent='Add an Instagram handle or phone number to continue.';
        setStickyErr('Add your Instagram or phone number so we can reach you.', errTargets.contact);
        primary.disabled=true; return;
      }
      setStickyErr('');
      primary.disabled=false;
    }
    function paintReview(){
      state.seenReview = true;
      state.fromFork = false;
      reviewHolds.forEach(function(fn){ try{ fn(); }catch(e){} }); reviewHolds.length=0;
      pruneDrafts();
      errTargets = {lost:[], short:{}, contact:null, fee:[], color:{}};
      var sh=root.querySelector('[data-ez-shared]');
      var dh=root.querySelector('[data-ez-designs]');
      sh.innerHTML=''; sh.hidden=true;
      dh.innerHTML='';
      groups.forEach(function(g, gx){
        var card=document.createElement('div'); card.className='ez-gcard';
        var head=document.createElement('div'); head.className='ez-ghead';
        var title=document.createElement('b');
        title.textContent = groups.length>1 ? ('Bag '+(gx+1)) : 'Your bag';
        head.appendChild(title);
        /* No "Tap anything to change it" hint here — the step intro
            already says it once, and every row carries a chevron. */
        if(groups.length>1){
          var rmg=document.createElement('button'); rmg.type='button'; rmg.className='ez-drm'; rmg.textContent='Remove';
          rmg.addEventListener('click', function(){
            groups.splice(gx,1);
            if(!groups.length) groups.push(newGroup());
            useGroup(Math.min(gi, groups.length-1), 0);
            groups.forEach(function(gg){ gg.S.total = groupTotalOf(gg) || gg.S.total; });
            paintReview();
            saveState();
          });
          head.appendChild(rmg);
        }
        card.appendChild(head);
        var chips=document.createElement('div'); chips.className='ez-gchips';
        function chip(cat, label, step, warn){
          var b=document.createElement('button'); b.type='button';
          var isLong = String(label).length > 28;
          b.className='ez-gchip'+(warn?' is-warn':'')+(isLong?' is-long':'');
          b.innerHTML=(cat?('<i class="ez-gchip-k">'+esc(cat)+'</i>'):'')+'<span>'+esc(label)+'</span><span class="ez-gchip-c" aria-hidden="true">\u203a</span>';
          b.setAttribute('aria-label','Change '+(cat?cat+': ':'')+label);
          b.addEventListener('click', function(){ editFrom(step, gx, 0); });
          chips.appendChild(b);
        }
        chip('Size', g.S.size || 'Pick a size', 'size');
        chip('Material', baseDisplay(g.S.base) || 'Pick a material', 'base');
        chip('Finish', finishLabel(g.S), 'finish');
        chip('Sides', g.S.sides==='Double' ? 'Front + back' : 'Front only', 'sides');
        var driftNote=null;
        if(specialOf(g.S) && FEE.length>0){
          var f=findFee(g.S.tier);
          var fsAll=g.designs.map(function(d){ return feeStateFor(g,d); });
          var allWaived = fsAll.length>0 && fsAll.every(function(x){ return x.waived; });
          var driftAt = -1;
          fsAll.forEach(function(x,i){ if(driftAt<0 && !x.waived && g.designs[i]._of) driftAt=i; });
          if(allWaived)              chip('Spot gloss file edits', 'Paid with '+fsAll[0].order, 'tier');
          else if(!feeAnswered(g.S, g)) { chip('Spot gloss file edits', 'Edit level needed', 'tier', true);
                                        errTargets.fee.push(chips.lastChild); }
          else                       chip('Spot gloss file edits', g.S.tier + (f ? (' \u00b7 '+money(f.price)) : ''), 'tier');
          /* the design was paid for on an earlier order but the file prep
              changed (style, size, artwork or QR) \u2014 say so where the fee shows,
              the way the labels page captions a changed design on file */
          if(!allWaived && driftAt>=0){
            driftNote=document.createElement('p'); driftNote.className='ez-sub2 ez-drift';
            driftNote.textContent='Changed from '+(g.designs[driftAt]._of.order||'your earlier order')+' \u2014 file setup applies again.';
          }
        }
        card.appendChild(chips);
        if(driftNote) card.appendChild(driftNote);
        g.designs.forEach(function(d, dx){
          var dcard=document.createElement('div');
          dcard.className='ez-dcard'+(designLost(g,d)?' needs-file':'');
          if(designLost(g,d)) errTargets.lost.push(dcard);
          if(g.S.size && !errTargets.short[g.S.size]) errTargets.short[g.S.size]=dcard;
          var top=document.createElement('div'); top.className='ez-dtop';
          var idx=document.createElement('span'); idx.className='ez-dnum'; idx.textContent=String(dx+1);
          top.appendChild(idx);
          var nm=document.createElement('button'); nm.type='button'; nm.className='ez-dname';
          nm.innerHTML='<b>'+esc(d.flavor||('Design '+(dx+1)))+'</b><span class="ez-gchip-e" aria-hidden="true">\u270e</span>';
          nm.addEventListener('click', function(){ editFrom('dart', gx, dx); });
          top.appendChild(nm);
          if(g.designs.length>1){
            var rm=document.createElement('button'); rm.type='button'; rm.className='ez-drm'; rm.textContent='Remove';
            rm.addEventListener('click', function(){
              g.designs.splice(dx,1);
              if(!g.designs.length) g.designs.push(newDesign());
              g.S.total = groupTotalOf(g);
              useGroup(gi, 0);
              paintReview();
              saveState();
            });
            top.appendChild(rm);
          }
          dcard.appendChild(top);
          var meta=document.createElement('div'); meta.className='ez-dmeta';
          var lost = designLost(g, d);
          function mrow(key, value, step, tone){
            var b=document.createElement('button'); b.type='button';
            b.className='ez-mrow'+(tone==='lost'?' is-lost':'');
            var vcls = (tone==='quiet') ? ' is-quiet' : '';
            b.innerHTML='<span class="ez-mk">'+esc(key)+'</span>'+
                        '<span class="ez-mv'+vcls+'">'+
                          (tone==='lost' ? '<span class="ez-warnpip" aria-hidden="true">!</span>' : '')+
                          esc(value)+
                        '</span>'+
                        '<span class="ez-mchev" aria-hidden="true">\u203a</span>';
            b.addEventListener('click', function(){ editFrom(step, gx, dx); });
            meta.appendChild(b);
            return b;
          }
          var tone = lost ? 'lost'
                   : ((artPending(d.front) || (g.S.sides==='Double' && artPending(d.back))) ? 'quiet' : '');
          var artStep = missingArtStep(g, d) || 'dart';
          mrow('Artwork', artSummary(g, d), artStep, tone);
          var crow=mrow('Color', d.color||'Pick one', 'dcolor', d.color?'':'lost');
          errTargets.color[d.id]=crow;
          if(d.qr || d.qrLink){
            mrow('QR code', qrSummary(d), 'dart',
                 (d.qr && (d.qr.oversize || d.qr.lost)) ? 'quiet' : '');
          }
          dcard.appendChild(meta);
          var qrow=document.createElement('div'); qrow.className='ez-qrow';
          qrow.innerHTML='<span class="ez-row-k">'+esc(unitWord().charAt(0).toUpperCase()+unitWord().slice(1))+'</span>';
          var ctl=document.createElement('div'); ctl.className='ez-qctl';
          var minus=document.createElement('button'); minus.type='button'; minus.className='ez-qbtn'; minus.setAttribute('aria-label','One fewer'); minus.innerHTML='&minus;';
          var val=document.createElement('input'); val.className='ez-qval'; val.type='text';
          val.setAttribute('inputmode','numeric'); val.setAttribute('pattern','[0-9]*');
          val.setAttribute('aria-label','How many '+unitWord());
          val.value=String(d.qty||0);
          var plus=document.createElement('button'); plus.type='button'; plus.className='ez-qbtn'; plus.setAttribute('aria-label','One more'); plus.textContent='+';
          ctl.appendChild(minus); ctl.appendChild(val); ctl.appendChild(plus);
          qrow.appendChild(ctl);
          dcard.appendChild(qrow);
          val.addEventListener('input', function(){
            var v=val.value.replace(/[^0-9]/g,'');
            if(v!==val.value) val.value=v;
            var n=parseInt(v,10);
            if(!isNaN(n) && n>0){
              d.qty=n;
              g.S.total=groupTotalOf(g);
              refreshTotals(); paintRunTotal(); saveSoon();
            }
          });
          val.addEventListener('blur', function(){
            var n=parseInt(val.value,10);
            d.qty = (isNaN(n)||n<1) ? 1 : n;
            val.value=String(d.qty);
            g.S.total=groupTotalOf(g);
            refreshTotals(); paintRunTotal(); saveSoon();
          });
          val.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); val.blur(); } });
          val.addEventListener('focus', function(){ val.select(); });
          bindQtyHold(minus, -1, d, g, val);
          bindQtyHold(plus,  +1, d, g, val);
          card.appendChild(dcard);
        });
        var addD=document.createElement('button'); addD.type='button'; addD.className='ez-addmore';
        addD.innerHTML='<span class="ez-add-plus" aria-hidden="true">+</span><b>Another design</b><small>same bags, new picture</small>';
        addD.addEventListener('click', function(){
          useGroup(gx, 0);
          designs.push(newDesign()); cur=designs.length-1;
          state.mode='design'; state.ret='review'; go('dart');
        });
        card.appendChild(addD);
        /* The pound-bag upsell used to render here, per group. Moved to the
            'dmore' ("Anything else?") fork 2026-07-31 (owner call) — that step IS the
            add-more moment, and the review stays a review. See paintStep('dmore'). */
        dh.appendChild(card);
      });
      root.querySelector('[data-ez-contact]').value = contact || '';
      errTargets.contact = root.querySelector('[data-ez-contact]');
      var addBag=root.querySelector('[data-ez-addbag]');
      if(addBag) addBag.closest('.ez-actions').hidden = !!EDIT;
      root.querySelectorAll('.ez-gcard .ez-addmore').forEach(function(b){ b.hidden = !!EDIT; });
      refreshTotals();
    }
    root.querySelector('[data-ez-contact]').addEventListener('input', function(e){
      contact=e.target.value;
      if(state.step==='review') refreshTotals();
      saveSoon();
    });
    function addGroup(fromReview, seed){
      groups.push(newGroup());
      useGroup(groups.length-1, 0);
      if(seed){
        S.size=seed.size; S.base=seed.base; S.finish=seed.finish; S.spot=seed.spot;
        S.sides=seed.sides; S.ready=seed.ready; S.readyAns=seed.readyAns; S.tier=seed.tier;
        S.totalTouched=false;
      }
      state.ret = fromReview ? 'review' : null;
      state.fromFork = !fromReview;
      state.mode='config';
      go(PRODUCTS.length>1 ? 'product' : 'size');
    }
    var addBagBtn = root.querySelector('[data-ez-addbag]');
    if(addBagBtn) addBagBtn.addEventListener('click', function(){ addGroup(true); });
    /* Matching pound bag, one tap. Suppressed when: the pound size is
        missing from the product, the group isn't finished, the group IS the pound
        size, a pound group with the same style already exists (covers both "already
        cloned" and "built one by hand" without persisting a marker), or the exact
        pound variant doesn't exist. Returns the variant so the card can price it. */
    function poundOfferFor(g){
      if(!PSIZE_OK || EDIT) return null;
      if(!groupDone(g)) return null;
      if(g.S.size===PSIZE) return null;
      var dup=groups.some(function(o){
        return o!==g && o.S.size===PSIZE && o.S.base===g.S.base &&
               (o.S.finish||'')===(g.S.finish||'') && !!o.S.spot===!!g.S.spot &&
               o.S.sides===g.S.sides;
      });
      if(dup) return null;
      return findVariant(g.S.base, g.S.finish||'', g.S.spot, PSIZE, g.S.sides||'Double');
    }
    function clonePoundGroup(gx){
      var g=groups[gx];
      if(!g || !poundOfferFor(g)) return;
      var ng=newGroup();
      ng.S.size=PSIZE;
      ng.S.base=g.S.base; ng.S.finish=g.S.finish; ng.S.spot=g.S.spot; ng.S.sides=g.S.sides;
      /* Fee fields copied as-is — a 13x15 layout is new setup work, so the
          clone charges the File Edit fee again (owner decision 2026-07-27); the card
          states it. Copying readyAns/tier also keeps feeAnswered() true so the clone
          survives pruneDrafts on reload. */
      ng.S.ready=g.S.ready; ng.S.readyAns=g.S.readyAns; ng.S.tier=g.S.tier;
      ng.S.total=g.designs.length;
      ng.S.totalTouched=true;
      var pColors=colorsFor(PSIZE, ng.S.base).map(function(c){ return c.label; });
      ng.designs=g.designs.map(function(d){
        var nd=newDesign();  /* fresh uid — clearPriorAttempt and the fee
            pairing key on _design_id, so a clone must never share one */
        nd.flavor=d.flavor; nd.notes=d.notes; nd.qrLink=d.qrLink;
        nd.qty=1;
        nd.color = (d.color===ANYCOLOR || pColors.indexOf(d.color)>=0) ? d.color : '';
        ['front','back','qr'].forEach(function(side){
          var f=d[side];
          if(!f) return;
          nd[side] = f.file ? (f.oversize ? {oversize:true, file:f.file, name:f.name}
                                          : {file:f.file, name:f.name})
                   : f.kept ? {kept:true, url:f.url, name:f.name}
                   : f.later ? {later:true}
                   : f.oversize ? {oversize:true, name:f.name}
                   : {lost:true, name:f.name};
          if(nd[side] && nd[side].file && !nd[side].oversize) idbSaveFile(nd.id, side, nd[side]);
        });
        return nd;
      });
      groups.push(ng);
      saveSoon();
      /* Clicked from the dmore fork (its only call site since 2026-07-31):
          land on the review so the buyer sees what they just added, then bring the new
          group card into view once go()'s ~330ms transition has settled. */
      go('review');
      setTimeout(function(){
        var cards=root.querySelectorAll('.ez-gcard');
        var nc=cards[cards.length-1];
        if(nc) nc.scrollIntoView({behavior:'smooth', block:'center'});
      }, 480);
    }
    var restoreX = root.querySelector('[data-ez-restorex]');
    if(restoreX) restoreX.addEventListener('click', function(){
      var el=root.querySelector('[data-ez-restore]');
      el.style.height=el.offsetHeight+'px'; void el.offsetWidth;
      el.classList.add('is-leaving');
      setTimeout(function(){
        el.hidden=true; el.classList.remove('is-leaving'); el.style.height='';
        if(state.step==='dcolor') fitColorGrid();
      }, 480);
    });
    var runTotBtn = root.querySelector('[data-ez-runtot]');
    var runTotArmTimer=null;
    function runTotWouldDrop(){
      /* mirror pruneDrafts: a design with qty==null is dropped when a DONE
         sibling exists (the all-null rescue only saves fully-fresh groups) —
         armed-confirm only when that drop would eat real work */
      var risk=false;
      groups.forEach(function(g){
        if(!g.designs.some(designDone)) return;
        g.designs.forEach(function(d){
          if(designDone(d)) return;
          if(d.front || d.back || d.qr || d.qrLink || d.color || d.flavor) risk=true;
        });
      });
      return risk;
    }
    function disarmRunTot(){
      if(!runTotBtn) return;
      clearTimeout(runTotArmTimer); runTotArmTimer=null;
      if(runTotBtn.classList.contains('is-armed')){
        runTotBtn.classList.remove('is-armed');
        paintRunTotal();
      }
    }
    if(runTotBtn) runTotBtn.addEventListener('click', function(){
      /* state.busy: the run-total sits OUTSIDE the stage the add-chain
          lock covers, and go('review') mid-add would repaint under the chain */
      if(state.busy || runTotBtn.disabled || !state.seenReview) return;
      /* the jump prunes half-built designs — a one-tap "See my order" was
         silently deleting uploaded artwork (audit 2026-08-24). Same two-tap
         arm as the review delete link; aria-live on the strip announces it. */
      if(runTotWouldDrop() && !runTotBtn.classList.contains('is-armed')){
        runTotBtn.classList.add('is-armed');
        runTotBtn.textContent='Tap again to leave this design';
        clearTimeout(runTotArmTimer);
        runTotArmTimer=setTimeout(disarmRunTot, 4000);
        return;
      }
      disarmRunTot();
      state.ret=null; state.mode='config'; state.splitMore=false;
      go('review');
    });
    var startOver = root.querySelector('[data-ez-startover]');
    var armTimer = null;
    var RESTING_LABEL = EDIT ? 'Discard my changes and start over' : 'Delete this order and start again';
    var ARMED_LABEL   = EDIT ? 'Tap again to discard'             : 'Tap again to delete everything';
    if(startOver) startOver.textContent = RESTING_LABEL;
    function disarmDelete(){
      if(!startOver) return;
      clearTimeout(armTimer); armTimer=null;
      startOver.classList.remove('is-armed');
      startOver.textContent=RESTING_LABEL;
    }
    if(startOver) startOver.addEventListener('click', function(){
      if(!startOver.classList.contains('is-armed')){
        startOver.classList.add('is-armed');
        startOver.textContent=ARMED_LABEL;
        clearTimeout(armTimer);
        armTimer=setTimeout(disarmDelete, 4000);
        return;
      }
      disarmDelete();
      state.busy = true;
      reset();
      state.seenReview=false; state.fromFork=false;
      contact='';
      killState();
      var params;
      try{ params = new URLSearchParams(window.location.search); }catch(e){ params = null; }
      if(params){
        ['edit','vid','did','size','style','sides','qty','design','color','notes','ready','front','frontname','back','backname','frontlater','backlater','qr','feekey','tier','ezfresh'].forEach(function(k){ params.delete(k); });
        params.set('ezfresh','1');
      }
      var qs = params ? ('?' + params.toString()) : '?ezfresh=1';
      var fresh = window.location.pathname + qs + window.location.hash;
      window.location.replace(fresh);
    });
    /* Single source of truth for the PENDING marker strings. The cart
        edit link and the team's order view key off the 'PENDING' prefix, and
        appendArt/keptProp/buildProps must emit identical wording — a drifted copy
        silently changes what the team is chasing after an edit. */
    function pendStr(f){
      if(!f) return null;
      if(f.later)    return 'PENDING: customer will send artwork after checkout (via phone or Instagram DM)';
      if(f.oversize) return 'PENDING: over '+MAXMB+' MB, collect from customer: '+f.name;
      if(f.lost)     return 'PENDING: customer to re-send (lost in draft): '+f.name;
      return null;
    }
    function appendArt(fd, label, f){
      if(!f) return;
      var ps=pendStr(f);
      if(ps)          fd.append('properties['+label+']', ps);
      else if(f.file) fd.append('properties['+label+']', f.file, f.name);
      else if(f.kept && f.url) fd.append('properties['+label+']', f.url);
    }
    function keptProp(fd, side, f){
      appendArt(fd, side==='front' ? 'Front artwork' : 'Back artwork', f);
    }
    function buildProps(g, d){
      var p={};
      p['Design'] = d.flavor || 'Design 1';
      p['Color']  = d.color || ANYCOLOR;
      p['Print-ready file'] = specialOf(g.S) ? (g.S.ready?'Yes':'No') : 'N/A';
      if(d.notes && d.notes.trim()) p['Notes'] = d.notes.trim();
      var pf=pendStr(d.front), pb=pendStr(d.back);
      if(pf) p['Front artwork'] = pf;
      else if(d.front && d.front.kept && d.front.url) p['Front artwork'] = d.front.url;
      if(g.S.sides==='Double'){
        if(pb) p['Back artwork'] = pb;
        else if(d.back && d.back.kept && d.back.url) p['Back artwork'] = d.back.url;
      }
      /* /cart/change.js REPLACES the whole properties object — anything
          not re-emitted here is silently dropped. The EDIT.qr fallback passes an
          undecoded value (e.g. a PENDING marker) through the edit verbatim. */
      if(d.qrLink) p['QR code'] = 'Generate from Instagram: '+d.qrLink;
      else if(d.qr && d.qr.kept && d.qr.url) p['QR code'] = d.qr.url;
      else if(EDIT && EDIT.qr) p['QR code'] = EDIT.qr;
      var fs=feeStateFor(g,d);
      p._design_id  = fs.did;
      p._src        = 'easy';
      p._pool_key   = (PROD.prefix || 'size:') + g.S.size;
      p._pool_min   = String(minForSize(g.S.size));
      p._pool_label = shortSize(g.S.size)+' '+unitWord();
      p._pool_ladder= ladderFor(g.S.size).map(function(t){ return t.min+':'+t.pct; }).join(',');
      if(fs.fee) p._fee_id = String(fs.fee.id);
      waiverProps(p, fs);
      return p;
    }
    /* ---- shared cart-chain plumbing (hoisted from addToCart 2026-08-24 so
       saveEdit runs behind the SAME veil + inert lock — the edit path ran the
       full cart chain with live review controls, the audit's P1) ---- */
    var veil=null;
    /* Quips are aria-hidden: the card is role=status and a line that
        swaps every 2.4s would spam screen readers — only real progress announces. */
    var QUIPS=['Heat-sealing the details…','Prepping your artwork for print…','Counting your bags twice…','Fresh packs incoming…'];
    function veilOn(){
      var card=document.createElement('div');
      card.className='smv2-atcveil-card'; card.setAttribute('role','status');
      card.innerHTML='<span class="smv2-loader" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span>'+
        '<span class="smv2-atcveil-txts"><span>Adding to your cart…</span><span class="smv2-atcveil-sub" aria-hidden="true"></span></span>';
      var txts=card.lastChild;
      txts.lastChild.textContent=QUIPS[0];
      document.body.appendChild(card);
      var dim=document.createElement('div'); dim.className='smv2-atcveil';
      document.body.appendChild(dim); /* full-viewport dim (fixed z 65) — covers header/footer too */
      var qi=0;
      var qt=setInterval(function(){ qi=(qi+1)%QUIPS.length; txts.lastChild.textContent=QUIPS[qi]; }, 2400);
      veil={card:card, tx:txts.firstChild, dim:dim, qt:qt};
    }
    function veilTx(t){ if(veil) veil.tx.textContent=t; }
    function veilOff(){
      if(!veil) return;
      clearInterval(veil.qt);
      veil.card.remove(); veil.dim.remove();
      veil=null;
    }
    function lockStage(on){
      try{ stage.inert = on; }catch(e2){}
      stage.classList.toggle('is-adding', on);
      if(on) veilOn(); else veilOff();
    }
    /* fetch() can't report upload progress; XHR can. Same contract as the
        fetch it replaces: resolves parsed JSON, rejects Error('bag') on any failure.
        Progress is capped at 99% — the bytes arriving is not the server done.
        onAbort: a superseded chain rejects distinctly so its catch can exit silent. */
    function postAdd(fd, onPct, onXhr){
      return new Promise(function(resolve, reject){
        var x=new XMLHttpRequest();
        x.open('POST','/cart/add.js');
        x.setRequestHeader('Accept','application/json');
        x.setRequestHeader('X-Requested-With','XMLHttpRequest');
        if(onXhr) onXhr(x);
        if(x.upload && onPct) x.upload.addEventListener('progress', function(e){
          if(e.lengthComputable && e.total>0) onPct(Math.min(99, Math.round(e.loaded/e.total*100)));
        });
        x.onload=function(){
          if(x.status>=200 && x.status<300){ var j={}; try{ j=JSON.parse(x.responseText); }catch(e2){} resolve(j); }
          else reject(new Error('bag'));
        };
        x.onerror=function(){ reject(new Error('bag')); };
        x.onabort=function(){ reject(new Error('superseded')); };
        x.send(fd);
      });
    }
    /* Line keys are NOT stable across cart mutations: /cart/add.js of another
        line re-hashes the existing keys (verified on the preview 2026-09-08 —
        the pooled volume discount re-allocates and Shopify re-keys), so a
        removal by the key the cart page rendered 400s silently once the
        replacement line is in. Resolve the line again from a fresh /cart.js
        by what it IS (design id + variant), falling back to the old key. */
    function liveKey(oldKey, isMatch){
      return fetch('/cart.js?t='+Date.now(),{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(c){
        var items=(c&&c.items)||[], hit=null;
        items.forEach(function(i){ if(!hit && i.key===oldKey) hit=i; });
        if(!hit) items.forEach(function(i){ if(!hit && isMatch(i)) hit=i; });
        return hit ? hit.key : oldKey;
      }).catch(function(){ return oldKey; });
    }

    function saveEdit(){
      var g=groups[0], d=g.designs[0];
      var v=findVariant(g.S.base, g.S.finish||'', g.S.spot, g.S.size, g.S.sides||'Double');
      if(!v) return;
      var err=root.querySelector('[data-ez-err]');
      state.busy=true; primary.disabled=true; primary.textContent='Saving\u2026'; err.hidden=true;
      paintChrome(); // hide Back etc. while busy \u2014 it stayed tappable and silently no-op'd for up to 15s
      /* Interaction floor (audit 2026-08-24): the edit-save chain mutates the
          cart exactly like addToCart, so it runs behind the SAME veil + inert
          lock \u2014 review steppers stayed live mid-save and could change the
          posted line after validation passed. */
      lockStage(true);
      veilTx('Saving your changes\u2026');
      // same hung-request watchdog as addToCart \u2014 see the comment there (jar port 08-05)
      clearTimeout(state.busyDog);
      state.busyDog=setTimeout(function(){
        if(!state.busy) return;
        lockStage(false);
        state.busy=false; primary.disabled=false; primary.textContent='Save changes';
        paintChrome();
        err.hidden=false;
        err.textContent='That\u2019s taking longer than it should \u2014 check your connection and tap again.';
      }, 15000);
      var sameVariant = String(v.id) === String(EDIT_VID);
      // change.js can carry everything EXCEPT a fresh File — kept URLs and PENDING
      // markers are strings. Only a new upload forces add-then-remove. That matters
      // beyond niceness: a re-add whose variant+properties match the old line
      // byte-for-byte MERGES on /cart/add.js (verified live: 64 + 64 = one line of
      // 128, re-keyed, so the old-key removal 400s) — a send-later line saved
      // unchanged would double itself.
      var noNewFiles  = !((d.front && d.front.file) || (d.back && d.back.file) || (d.qr && d.qr.file));
      /* through the waiver judge: a reordered line whose prep is unchanged owes
          no companion (newFee null), so the branches below add none and remove
          any stale one; a drifted line re-acquires the fee like a fresh design */
      var fs = feeStateFor(g,d);
      var nf = !!fs.fee;
      var newFee = fs.fee;
      var addedKey = '';
      var ops=[];
      if(sameVariant && noNewFiles){
        ops.push(function(){
          return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({ id:EDIT_KEY, quantity:d.qty||0, properties:buildProps(g,d) })
          }).then(function(r){ if(!r.ok) throw new Error('save'); return r.json(); });
        });
      } else {
        // ADD the replacement FIRST, then remove the old line. The reverse
        // (remove-then-add) loses the customer's bag AND their re-uploaded
        // artwork if the add fails mid-flight, leaving an error that doesn't say
        // the line is gone. The removal is non-fatal: a transient duplicate the
        // customer can see and remove beats a silently vanished order line.
        ops.push(function(){
          var fd=new FormData();
          fd.append('id', v.id);
          fd.append('quantity', d.qty||0);
          var p=buildProps(g,d);
          Object.keys(p).forEach(function(k){
            if(k==='Front artwork' || k==='Back artwork' || k==='QR code') return;
            fd.append('properties['+k+']', p[k]);
          });
          keptProp(fd,'front',d.front);
          keptProp(fd,'back', g.S.sides==='Double' ? d.back : null);
          if(d.qrLink) fd.append('properties[QR code]', 'Generate from Instagram: '+d.qrLink);
          else if(d.qr) appendArt(fd, 'QR code', d.qr);
          else if(EDIT && EDIT.qr) fd.append('properties[QR code]', EDIT.qr);
          return postAdd(fd, function(p){ veilTx('Saving your changes\u2026 '+p+'%'); })
            .then(function(j){ addedKey = (j && j.key) || ''; return j; })
            .catch(function(){ throw new Error('save'); });
        });
        ops.push(function(){
          // the old line, found again by identity \u2014 its key may have moved (see liveKey)
          return liveKey(EDIT_KEY, function(i){ var p=i.properties||{};
              return p._fee_line!=='1' && p._design_id===EDIT_DID && String(i.variant_id)===String(EDIT_VID) && i.key!==addedKey; })
            .then(function(k){
              return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
                body:JSON.stringify({ id:k, quantity:0 })
              }).then(function(r){ return r.ok ? r.json() : null; });
            }).catch(function(){ return null; });
        });
      }
      var tierChanged = EDIT.tier && newFee && (EDIT.tier !== g.S.tier);
      if(EDIT_FEEKEY && (!nf || tierChanged)){
        ops.push(function(){
          var feeVid = String(EDIT_FEEKEY).split(':')[0];
          return liveKey(EDIT_FEEKEY, function(i){ var p=i.properties||{};
              return p._fee_line==='1' && p._design_id===EDIT_DID && String(i.variant_id)===feeVid; })
            .then(function(k){
              return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
                body:JSON.stringify({ id:k, quantity:0 })
              }).then(function(r){ return r.ok ? r.json() : null; });
            });
        });
      }
      if(nf && newFee && (!EDIT_FEEKEY || tierChanged)){
        ops.push(function(){
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({ id:newFee.id, quantity:1,
              properties:{ 'For': d.flavor || 'Design 1', 'Setup': g.S.tier, _design_id: d.id, _fee_line:'1' } })
          }).then(function(r){ return r.ok ? r.json() : null; });
        });
      }
      ops.reduce(function(p,op){ return p.then(op); }, Promise.resolve())
        .then(function(){ clearTimeout(state.busyDog); veilTx('Saved \u2014 opening your cart\u2026'); window.location.href='/cart'; })
        .catch(function(){
          clearTimeout(state.busyDog);
          lockStage(false);
          state.busy=false; primary.disabled=false; primary.textContent='Save changes';
          paintChrome();
          err.hidden=false;
          err.textContent='We couldn\u2019t save that change. Open your cart to check it, then try again.';
        });
    }
    function addToCart(){
      var err=root.querySelector('[data-ez-err]');
      var short=shortages();
      if(short.length){
        var s0=short[0];
        setStickyErr('Add '+s0.need+' more '+shortSize(s0.size)+' '+unitFor(s0.need)+'. The minimum is '+s0.min+'.',
                     errTargets.short[s0.size]);
        return;
      }
      var lostAny=false;
      groups.forEach(function(g){ g.designs.forEach(function(d){ if(designLost(g,d)) lostAny=true; }); });
      if(lostAny){
        setStickyErr('Every design needs its artwork before you can order.', errTargets.lost[0]);
        return;
      }
      var noCol=null;
      groups.forEach(function(g){ g.designs.forEach(function(d){ if(!noCol && !d.color) noCol=d; }); });
      if(noCol){
        setStickyErr('Pick a bag color for '+(noCol.flavor||'your design')+'.', errTargets.color[noCol.id]||null);
        return;
      }
      var bad=null;
      groups.forEach(function(g){ if(!bad && !feeAnswered(g.S, g)) bad=g; });
      if(bad){
        err.hidden=false;
        err.textContent='Pick a spot gloss file edit level for '+styleDisplay(bad.S)+' before we add this to your cart.';
        editFrom('tier', groups.indexOf(bad), 0);
        return;
      }
      if(needsContact() && !(contact||'').trim()){
        var ce=root.querySelector('[data-ez-contacterr]');
        ce.hidden=false;
        ce.textContent='We need this so we can collect your artwork file.';
        root.querySelector('[data-ez-contact]').focus();
        return;
      }
      state.busy=true; primary.disabled=true; err.hidden=true;
      /* Lock the stage while the chain runs. Not cosmetic: the ops build
          their FormData at RUN time, reading d.qty live — so a stepper tapped mid-add
          changed what later lines put in the cart, after clearPriorAttempt had already
          run. inert blocks pointer AND keyboard (iOS 15.5+); the class is the
          pointer-events fallback. Must be released on EVERY exit below. */
      /* The veil (shared .smv2-atcveil* styles in sm-v2.css) says WHY the
          locked controls aren't responding: region dim + a viewport-centered status
          card carrying the same live progress text as the CTA. Card goes on <body> —
          position:fixed under a transformed ancestor degrades to absolute. */
      /* Hung-request watchdog (jar port 08-05), rebuilt 2026-08-24: the flat
          15s timer was armed ONCE for the whole chain and never fed, so a
          healthy large upload on a slow connection was declared dead mid-flight
          (audit P1) — and the abandoned chain kept running, so a late success
          plus the invited retry doubled bag and fee lines. The dog is now FED
          by upload progress and every op boundary; firing invalidates the
          chain's generation and aborts the in-flight upload, so a retry can
          never race its predecessor. */
      var gen = state.atcGen = (state.atcGen||0)+1;
      var curXhr=null;
      function dogFire(){
        if(!state.busy) return;
        state.atcGen++; /* no further ops from this chain */
        if(curXhr){ try{ curXhr.abort(); }catch(e2){} }
        lockStage(false); /* also drops the veil */
        state.busy=false; primary.disabled=false;
        primary.textContent = EDIT ? 'Save changes' : 'Add to cart';
        err.hidden=false;
        err.textContent='That\u2019s taking longer than it should \u2014 check your connection and tap again.';
      }
      function armDog(){ clearTimeout(state.busyDog); state.busyDog=setTimeout(dogFire, 15000); }
      armDog();
      lockStage(true);
      /* Live progress on the button itself. The chain uploads print-res
          artwork over Meta's in-app browser (~82% of traffic), so the wait is real and
          unavoidable \u2014 what was missing was any sign of motion. Labels are count-only
          strings (no user text), safe for innerHTML next to the spinner span. */
      function setAtcMsg(txt, pct){
        var t=txt+(pct!=null?(' '+pct+'%'):'');
        primary.innerHTML='<span class="ez-spin" aria-hidden="true"></span>'+t;
        veilTx(t);
      }
      setAtcMsg('Adding to your cart\u2026');
      var ops=[], noteLines=[];
      var nAll=0; groups.forEach(function(g){ nAll += g.designs.length; });
      var dIdx=0;
      groups.forEach(function(g, gx){
        var v=findVariant(g.S.base, g.S.finish||'', g.S.spot, g.S.size, g.S.sides||'Double');
        if(!v) return;
        var prefix = (PROD.prefix || 'size:');
        g.designs.forEach(function(d, dx){
          var label = d.flavor || ('Design '+(dx+1));
          // per design: a design on file keeps its paid prep, a fresh one pays
          var fs = feeStateFor(g,d);
          var gNeedsFee = !!fs.fee;
          dIdx++;
          var hasUpload = !!((d.front && d.front.file) || (d.back && d.back.file) || (!d.qrLink && d.qr && d.qr.file));
          var verb = hasUpload ? 'Uploading' : 'Adding';
          var opLab = nAll>1 ? (verb+' design '+dIdx+' of '+nAll+'\u2026') : (verb+' your design\u2026');
          ops.push({lab:opLab, run:function(){
            var fd=new FormData();
            fd.append('id', v.id);
            fd.append('quantity', d.qty||0);
            fd.append('properties[Design]', label);
            fd.append('properties[Color]', d.color||ANYCOLOR);
            fd.append('properties[Print-ready file]', specialOf(g.S) ? (g.S.ready?'Yes':'No') : 'N/A');
            if(d.notes && d.notes.trim()) fd.append('properties[Notes]', d.notes.trim());
            appendArt(fd, 'Front artwork', d.front);
            appendArt(fd, 'Back artwork',  g.S.sides==='Double' ? d.back : null);
            if(d.qrLink) fd.append('properties[QR code]', 'Generate from Instagram: '+d.qrLink);
            else appendArt(fd, 'QR code', d.qr);
            fd.append('properties[_design_id]', fs.did);
            fd.append('properties[_src]', 'easy');
            fd.append('properties[_pool_key]', prefix + g.S.size);
            fd.append('properties[_pool_min]', String(minForSize(g.S.size)));
            fd.append('properties[_pool_label]', shortSize(g.S.size)+' '+unitWord());
            fd.append('properties[_pool_ladder]', ladderFor(g.S.size).map(function(t){ return t.min+':'+t.pct; }).join(','));
            if(fs.fee) fd.append('properties[_fee_id]', fs.fee.id);
            if(fs.waived){ var wp=waiverProps({}, fs); Object.keys(wp).forEach(function(k){ fd.append('properties['+k+']', wp[k]); }); }
            return postAdd(fd, hasUpload ? function(p){ armDog(); setAtcMsg(opLab, p); } : null, function(x){ curXhr=x; });
          }});
          if(gNeedsFee){
            ops.push({lab:'Adding spot gloss file edits…', run:function(){
              var ff2=fs.fee; if(!ff2) return null;
              return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
                body:JSON.stringify({ id:ff2.id, quantity:1,
                  properties:{ 'For':label, 'Setup':g.S.tier, _design_id:fs.did, _fee_line:'1' } })
              }).then(function(r){ if(!r.ok) throw new Error('fee'); return r.json(); });
            }});
          }
          noteLines.push(label+', '+styleOf(g.S)+', '+g.S.size+', '+
            (g.S.sides==='Double'?'double-sided':'single-sided')+', '+(d.color||ANYCOLOR)+', '+
            (d.qty||0)+' '+unitFor(d.qty||0)+(gNeedsFee?(', spot gloss file edits: '+g.S.tier):'')+
            (fs.waived?(', file edits paid with '+fs.order):''));
        });
      });
      ops.push({lab:'Finishing up…', run:function(){
        var attrs={ 'Custom bag run':'Custom bag run:\n'+noteLines.join('\n') };
        var cv=(contact||'').trim();
        if(cv) attrs['Customer contact']=cv.slice(0,120);
        return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({attributes:attrs})}).catch(function(){});
      }});
      /* The ops chain is sequential, so a failure mid-chain leaves the EARLIER
          lines committed. /cart/add.js MERGES an add whose properties match an existing line
          (verified: 40 + 40 = one line of 80), so a buyer who taps Add again after that
          failure doubles every line that already went through. Wipe our own half-written
          attempt first — the same guard the multi builder already uses. Lines are matched by
          _design_id, which both the bag line and its fee line carry. */
      function clearPriorAttempt(){
        var ids={};
        groups.forEach(function(g){ g.designs.forEach(function(d){ ids[d.id]=true; }); });
        return fetch('/cart.js',{cache:'no-store',headers:{'Accept':'application/json'}})
          .then(function(r){ return r.ok ? r.json() : {items:[]}; })
          .then(function(c){
            var upd={};
            (c.items||[]).forEach(function(i){
              var did=(i.properties||{})._design_id;
              if(did && ids[did] && i.key!==EDIT_KEY) upd[i.key]=0;
            });
            if(!Object.keys(upd).length) return;
            return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
              body:JSON.stringify({updates:upd})});
          }).catch(function(){});
      }
      clearPriorAttempt()
        .then(function(){ return ops.reduce(function(p,op){
          return p.then(function(){
            if(gen!==state.atcGen) throw new Error('superseded');
            armDog();
            setAtcMsg(op.lab); return op.run();
          });
        }, Promise.resolve()); })
        .then(function(){
          if(gen!==state.atcGen) return; /* watchdog already handed control back */
          groups.forEach(function(g){
            var add=0; g.designs.forEach(function(x){ add += (x.qty||0); });
            if(g.S.size) CARTPOOLS[g.S.size]=(CARTPOOLS[g.S.size]||0)+add;
          });
          /* This used to location.replace(...?ezdone=1) and rebuild the whole
              ~600KB document just to show the done screen — seconds of blank on the in-app
              browsers most buyers use, AFTER the adds had already finished. Show it in
              place instead, replicating exactly what the ezdone boot did: DONE carries the
              stats for paintStep('done'), killState() kills the persisted draft (and sets
              the dead flag — saveState() is guarded on it AND on step==='done', so the
              fresh state below cannot re-persist), reset() clears the in-memory order so
              nothing paints from the just-added bags. */
          var dTot=0, dCount=0;
          groups.forEach(function(g){ g.designs.forEach(function(x){ dTot+=(x.qty||0); dCount++; }); });
          DONE = { tot:dTot, designs:dCount, groups:groups.length, unit:unitWord() };
          clearTimeout(state.busyDog);
          killState();
          reset();
          lockStage(false); /* the done step lives inside the stage */
          state.busy=false;
          state.ret=null; state.splitMore=false; state.seenReview=false; state.fromFork=false; state.undo=null;
          go('done');
          return;
        })
        .catch(function(e){
          if((e && e.message==='superseded') || gen!==state.atcGen) return; /* dogFire spoke already */
          clearTimeout(state.busyDog);
          lockStage(false);
          state.busy=false; primary.disabled=false; primary.textContent='Add to cart';
          err.hidden=false;
          err.textContent = (e && e.message==='fee')
            ? 'Your bags were added, but a file-setup charge didn\u2019t go through. Open your cart and tap checkout, and it fixes this on its own.'
            : 'Something went wrong. Some bags may already be in your cart, so open your cart to check before trying again.';
        });
    }
    primary.addEventListener('click', function(){
      if(state.busy || navBusy) return;
      /* Ghosted CTA is now clickable (pointer-events:none dropped) so a tap can
          answer instead of falling through to the inert .ez-cta wrapper. */
      if(primary.classList.contains('is-ghosted')){ nudgeStepOptions(); return; }
      var s=state.step;
      if(s==='intro'){
        reviveState();
        go(PRODUCTS.length>1 ? 'product' : 'size');
        return;
      }
      if(s==='done'){ window.location.href='/cart'; return; }
      if(s==='review'){ if(EDIT){ saveEdit(); } else { addToCart(); } return; }
      if(s==='finish' && state.ret==='review' && !feeAnswered(S, groups[gi])){
        go('tier');
        return;
      }
      if(s==='dart'){
        D().flavor=root.querySelector('[data-ez-name]').value.trim();
        D().notes=root.querySelector('[data-ez-notes]').value;
        paintBadge();
      }
      if(s==='gsplit'){
        var nk = state.splitMore ? (parseInt(sCountInp.value,10) || designs.length) : designs.length;
        /* "Keep N designs" must KEEP: re-split only when the count changes or
           the amounts no longer add up (fresh flow: qtys are null so
           groupQty()===0 !== S.total and the first split still runs) —
           an even re-split silently wiped typed per-design amounts
           (audit 2026-08-24). */
        if(nk !== designs.length || groupQty() !== S.total) applySplit(nk);
        state.splitMore=false;
      }
      if(s==='gtotal'){
        var tq=parseInt(totInp.value,10); S.total=(isNaN(tq)||tq<1)?totMin():tq;
        if(BULK>0 && S.total>=BULK){ go('bulk'); return; }
        if(state.ret==='review'){ go('gsplit'); return; }
      }
      if(s==='dqty'){
        D().qty=clampQty(parseInt(qtyInp.value,10));
        paintQty();
        if(BULK>0 && D().qty>=BULK && state.ret!=='review'){ go('bulk'); return; }
      }
      advance();
    });
    var fitRAF=null;
    function fitCard(){
      if(!card) return;
      if(state.step==='review'){ root.style.removeProperty('--ez-h'); return; }
      var vv = window.visualViewport;
      var vh = vv ? vv.height : window.innerHeight;
      var top = card.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
      var rs  = getComputedStyle(root);
      var padB = parseFloat(rs.paddingBottom) || 0;
      var h = Math.max(460, Math.round(vh - top - padB));
      // --ez-h is an INHERITED custom property on the section root, consumed by
      // .ez-card{height:var(--ez-h)}. Writing it invalidates style for the whole
      // builder subtree, and paintChrome runs twice per transition — so an
      // unconditional write cost two full-subtree restyles per step for a value
      // that almost never changes.
      if(root.style.getPropertyValue('--ez-h') === h + 'px') return;
      root.style.setProperty('--ez-h', h + 'px');
    }
    var lastFitW = window.innerWidth;
    function fitSoon(){ if(fitRAF) cancelAnimationFrame(fitRAF); fitRAF=requestAnimationFrame(fitAll); }
    function fitSoonWidth(){
      var w = window.innerWidth;
      if(w === lastFitW) return;
      lastFitW = w;
      fitSoon();
    }
    function fitAll(){
      fitCard();
      if(state.step==='dcolor') fitColorGrid();
      paintChrome();
    }
    fitCard();
    window.addEventListener('resize', fitSoonWidth);
    window.addEventListener('orientationchange', function(){ lastFitW = window.innerWidth; setTimeout(fitAll, 250); });
    if(window.visualViewport){ window.visualViewport.addEventListener('resize', fitSoonWidth); }
    setTimeout(fitCard, 400);
    if(EDIT){
      var g0=groups[0];
      g0.S.size  = EDIT.size;
      g0.S.sides = (EDIT.sides === 'Double-sided') ? 'Double' : 'Single';
      unpackStyle(g0.S, EDIT.style);
      /* Opt-out removed 2026-07-31: a pre-change line whose buyer skipped
          the fee gets the default edit level on edit — the fee is now mandatory. */
      g0.S.readyAns = specialOf(g0.S) ? 'No' : null;
      g0.S.ready    = false;
      g0.S.tier     = specialOf(g0.S) ? (EDIT.tier || DEFAULT_TIER) : '';
      var d0=g0.designs[0];
      d0.id     = EDIT.did || d0.id;
      d0.flavor = EDIT.design;
      d0.notes  = EDIT.notes;
      d0.color  = EDIT.color;
      d0.qty    = EDIT.qty;
      if(EDIT.front) d0.front = {kept:true, url:EDIT.front, name:EDIT.frontname || 'your file'};
      if(EDIT.back)  d0.back  = {kept:true, url:EDIT.back,  name:EDIT.backname  || 'your file'};
      /* A PENDING side re-enters as a live send-later slot (kept URL
          wins if both somehow arrive). Without this the line came back as "Missing,
          add it" with Save blocked, though the cart line was fine. saveEdit
          re-emits the canonical PENDING string (buildProps on the in-place path,
          keptProp on re-add), so the marker survives the round trip. All PENDING
          kinds collapse to send-later on edit — an oversize marker loses its
          filename, but the artwork-owed signal and the contact chase both
          survive. */
      if(!d0.front && EDIT.frontlater) d0.front = {later:true};
      if(g0.S.sides==='Double' && !d0.back && EDIT.backlater) d0.back = {later:true};
      // Contact rides on the cart attribute; if /cart.js already answered, seed it
      // now — otherwise the fetch callback does it and repaints (order varies).
      if((EDIT.frontlater || EDIT.backlater) && !contact && CARTCONTACT) contact = CARTCONTACT;
      if(EDIT.qr){
        var qv=EDIT.qr;
        if(safeUrl(qv) && qv.indexOf('/uploads/')>=0){
          d0.qr = {kept:true, url:qv, name:(qv.split('/').pop()||'your file').split('?')[0]};
        } else if(qv.indexOf('Generate from Instagram: ')===0){
          d0.qrLink = normIg(qv.slice('Generate from Instagram: '.length));
        }
        /* Anything else (PENDING markers) stays undecoded on EDIT.qr;
            buildProps/saveEdit re-emit it verbatim so the edit can't drop it. */
      }
      /* The line's setup fee was paid on an earlier order (dashboard reorder,
          2026-09-08): remember what was paid for so feeStateFor() keeps the
          waiver while the prep is unchanged and re-charges honestly when it
          is not. The tier fallback above stays — it is what a drifted design
          is charged at. */
      if(EDIT.waived){
        d0._of = { did:EDIT.did, order:EDIT.reorderOf, style:EDIT.style, size:EDIT.size,
                   front:EDIT.front, back:EDIT.back, qr:EDIT.qr, paid:true, tier:EDIT.tier };
      }
      useGroup(0,0);
      Object.keys(steps).forEach(function(k){ steps[k].hidden = k!=='review'; });
      state.step='review';
      state.seenReview=true;
      paintStep('review');
      paintChrome();
    } else if(DONE){
      Object.keys(steps).forEach(function(k){ steps[k].hidden = k!=='done'; });
      state.step='done';
      paintStep('done');
      paintChrome();
    } else if(restoreState()){
      Object.keys(steps).forEach(function(k){ steps[k].hidden = k!==state.step; });
      paintStep(state.step);
      paintChrome();
      showRestoreNotice();
      afterShow(state.step);
      hydrateFiles();
    } else {
      Object.keys(steps).forEach(function(k){ steps[k].hidden = k!=='intro'; });
      paintChrome();
    }
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', function(e){
    var el2=document.querySelector('[data-ez-cfg]');
    if(el2 && e.detail && e.detail.sectionId===el2.getAttribute('data-ez-cfg')){ var r=document.getElementById(SID); if(r) delete r.dataset.ezInit; init(); }
  });
})();
